import { Location } from '@angular/common';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import {
  AfterViewChecked,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import {
  catchError,
  forkJoin,
  interval,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  take,
  takeUntil,
  timer,
} from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import {
  BACK_BUTTON,
  BACK_TO_POLICY_BUTTON,
  EModalOutput,
} from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import {
  EDashboardStatus,
  TDashboardStatus,
} from 'src/app/pages/dashboard/dashboard.constants';
import { DashboardService } from 'src/app/pages/dashboard/dashboard.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { FormUtils } from 'src/app/utils/FormUtils';
import { IsvUtils } from 'src/app/utils/IsvUtils';
import {
  COD_COLLEGAMENTI_ATTIVI_AMMESSI,
  ERR_DOC_RETRIEVE_MESSAGE,
  ERROR_DOWNLOADING_DOC_MESSAGE,
  ICancelDocument,
  ICompanyDocumentResponse,
  IDocument,
  IIbanObject,
} from '../athora/athora.constants';
import {
  bank_account_update_form_template,
  bank_account_update_form_validators,
} from '../athora/components/bank-account-update/bank-account-update.constants';
import { PolicyService } from '../policy/policy.service';
import { BasicModalComponent } from '../shared/components/basic-modal/basic-modal.component';
import {
  NO_BUTTON,
  YES_BUTTON,
} from '../shared/components/basic-modal/basic-modal.constants';
import {
  frequency_premium_amount_change_previdenziali_form_template,
  frequency_premium_amount_change_previdenziali_form_validators,
  variation_options_form_template,
  variation_options_form_validators,
} from '../shared/components/frequency-premium-change/frequency-premium-change.constants';
import {
  liquidation_maturity_form_template,
  liquidation_maturity_form_validators,
} from '../shared/components/liquidation-maturity/liquidation-maturity.constants';
import {
  IAnagrafica,
  ndg_variation_form_template,
  ndg_variation_form_validators,
} from '../shared/components/ndg-variation/ndg-variation.constants';
import {
  premium_payment_reactivation_form_template,
  premium_payment_reactivation_form_validators,
} from '../shared/components/premium-payment-reactivation/premium-payment-reactivation.constants';
import {
  premium_payment_suspension_form_template,
  premium_payment_suspension_form_validators,
} from '../shared/components/premium-payment-suspension/premium-payment-suspension.constants';
import {
  isv_total_redeem_form_template,
  isv_total_redeem_form_validators,
} from '../shared/components/total-redeem/total-redeem.constants';
import { IFormSelectOption } from '../shared/models/forms';
import {
  IDashboardOperation,
  IDraft,
  IDraftItem,
} from '../shared/models/operation.model';
import {
  EPolicyCompany,
  IBeneficiarioPrevidenziale,
  IFigureAnagrafiche,
  IInvestmentLine,
  ILegalPersonIntesa,
  IOperationFilter,
  IPagatore,
  IPersonIntesa,
  IPolicyAsset,
  IPolicyOperation,
} from '../shared/models/policy.model';
import { IUploadDocumentObj } from './../athora/components/document-upload/document-upload.constants';
import {
  payment_form_template,
  payment_form_validators,
  prev_payment_form_template,
  prev_payment_form_validators,
} from './components/additional-payment/additional-payment.constants';
import {
  bank_account_change_form_template,
  bank_account_change_form_validators,
} from './components/bank-account-change-isv/bank-account-change-isv.constants';
import {
  beneficiary_change_form_template_previdential_intros,
  beneficiary_change_form_validators_previdential_intros,
  IPrevidentialBeneficiaryType,
  IPrevidentialRequestModel,
} from './components/beneficiary-change-isp/beneficiary-change-isp.constants';
import {
  IDocumentUpdate,
  ILifeDeathBeneficiary,
  IPersonDataIsv,
} from './components/beneficiary-change-isv/beneficiary-change-isv.constants';
import { ESpecificBeneficiaryType } from './components/beneficiary-form-isv/beneficiary-form-isv.constants';
import {
  branch_office_variation_form_template,
  branch_office_variation_form_validators,
} from './components/branch-office-variation/branch-office-variation.constants';
import {
  divestment_isp_form_template,
  divestment_isp_form_validators,
} from './components/branch-switch-divestment-intesa/branch-switch-divestment-intesa.constants';
import {
  investment_isp_form_template,
  investment_isp_form_validators,
} from './components/branch-switch-investment-intesa/branch-switch-investment-intesa.constants';
import {
  previdential_change_investment_line_form_template,
  previdential_change_investment_line_form_validators,
} from './components/change-investment-line-isp/change-investment-line-isp.constants';
import {
  life_change_investment_line_form_template,
  life_change_investment_line_form_validators,
} from './components/change-investment-line-isv/change-investment-line-isv.constants';
import {
  claim_notification_validators,
  declarant_claim_notification_template,
  declarant_claim_notification_validators,
} from './components/claim-notification-isv/claim-notification-isv.constants';
import {
  isv_tutor_proper_verification_form_template,
  isv_tutor_proper_verification_form_validators,
  legal_guardian_form_template,
  legal_guardian_form_validators,
  search_form_template,
  search_form_validators,
} from './components/contractor-change-isv/contractor-change-isv.constants';
import {
  debit_date_form_template,
  debit_date_form_validators,
} from './components/debit-date-variation/debit-date-variation.constant';
import {
  document_change_form_template,
  document_change_form_validators,
  document_change_previdence_form_template,
  document_change_previdence_form_validators,
} from './components/document-change/document-change.constants';
import {
  isv_partial_redeem_form_template,
  isv_partial_redeem_form_validators,
} from './components/partial-redeem-isv/partial-redeem-isv.constants';
import { funds_relocation_form_template } from './components/redirect-funds/redirect-funds.constants';
import { registry_adjustment_form_validators } from './components/registry-adjustment/registry-adjustment.constants';
import {
  isv_contractor_address_form_template,
  isv_contractor_address_form_validators,
  isv_contractor_business_form_validators,
  isv_contractor_registry_form_validators,
  isv_contractor_residence_form_template,
  isv_contractor_residence_form_validators,
  isv_legal_guardian_registry_form_validators,
  isv_new_contractor_business_form_validators,
  isv_new_contractor_registry_form_validators,
  isv_PG_contractor_business_form_validators,
  privacy_consents_form_template,
  privacy_consents_form_validators,
  privacy_consents_PG_form_template,
  privacy_consents_PG_form_validators,
  proper_verification_form_template,
  proper_verification_form_validators,
} from './components/registry-form/registry-form.constants';
import {
  beneficiary_form_template,
  beneficiary_form_validators,
  insured_form_template,
  insured_form_validators,
  operator_data_form_template,
  operator_data_form_validators,
} from './components/registry-recap/registry-recap.constants';
import {
  residence_change_previdence_form_template,
  residence_change_previdence_form_validators,
} from './components/residence-change-isv/residence-change-isv.constants';
import {
  retirement_date_form_template,
  retirement_date_form_validators,
} from './components/retirement-date-variation/retirement-date-variation.constants';
import { EmployerTableRow } from './components/spostamento-iscritto/spostamento-iscritto.constants';
import {
  CAN_CHANGE_NDG_ISV,
  CHECK_REDEEM_INTENT_MSG,
  CHECK_TUTOR_MSG,
  COMPLETED_OPERATION_STATES,
  CONNOT_CALL_FORM_FIELDS,
  DIFFERENT_OP_COMPLETED_MSG,
  DIFFERENT_OP_DRAFT_MSG,
  HOLDER_NOT_REDEEMING_MSG,
  IIntesaFormFieldsResponse,
  INSURED_NOT_ALIVE_MSG,
  IPersonIntestaFormGroups,
  ISV_CANCEL_OPERATIONS,
  ISV_MULTI_STEP_OPERATIONS,
  ISV_OPERATION_NOT_PERMITTED_MSG,
  ISV_OPERATIONS_WITH_IBAN,
  NOT_DRAFT_OPERATION_STATES,
  OP_COMPLETED_MSG,
  OP_WITH_INSURED_CHECK,
  OP_WITH_QUESTIONNAIRE_UNI20,
  OP_WITH_QUESTIONNAIRE_UNI30,
  SAME_OP_COMPLETED_MSG,
} from './isv.constants';
import { IsvService } from './isv.service';
import moment = require('moment');

@Component({
  selector: 'app-isv',
  templateUrl: './isv.component.html',
  styleUrl: './isv.component.scss',
})
export class IsvComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('isvStepper') isvStepper: MatStepper;

  isOperationPermitted: boolean = true;

  ndgVariationForm: FormGroup;

  customerHasTutor: boolean = false;
  ndgVariationList: IAnagrafica[] = null;
  searchedTutor: IAnagrafica = null;

  contractorRegistryForm: FormGroup;
  contractorResidenceForm: FormGroup;
  contractorAddressForm: FormGroup;
  contractorIdentificationDocumentForm: FormGroup;
  contractorBusinessForm: FormGroup;

  newContractorProperVerificationForm: FormGroup;
  newContractorConsentsForm: FormGroup;

  operationDataForm: FormGroup;
  operatorDataForm: FormGroup;

  legalGuardianRegistryForm: FormGroup;
  legalGuardianResidenceForm: FormGroup;
  legalGuardianAddressForm: FormGroup;
  legalGuardianIdentificationDocumentForm: FormGroup;
  legalGuardianProperVerificationForm: FormGroup;

  searchedLegalGuardian: any;

  effectiveOwnersList: IPersonIntestaFormGroups[] = [];
  beneficiariesPrevidential: IPrevidentialRequestModel[] = [];

  insuredForm: FormGroup;
  beneficiaryForm: FormGroup;

  firstStepForm: FormGroup;
  additionalForm: FormGroup;
  ibansList: IIbanObject[] = null;
  documentTypeList: IFormSelectOption[] = null;
  documentReleaseAuthorityList: IFormSelectOption[] = null;
  activityTypes: IFormSelectOption[] = null;
  saeList: IFormSelectOption[] = null;
  taeList: IFormSelectOption[] = null;
  atecoList: IFormSelectOption[] = null;
  countriesList: IFormSelectOption[] = null;
  comuniList: IFormSelectOption[] = null;
  provincesList: IFormSelectOption[] = null;
  placesList: IFormSelectOption[] = null;
  holderBeneficiaryRelationshipList: IFormSelectOption[] = null;
  insuredBeneficiaryRelationshipList: IFormSelectOption[] = null;
  beneficiaryDeathTipologies: IFormSelectOption[] = null;
  beneficiaryLifeTipologies: IFormSelectOption[] = null;
  agreementPurposeList?: IFormSelectOption[] = null;
  customerBehaviourList?: IFormSelectOption[] = null;
  documentationList?: IFormSelectOption[] = null;
  fundsOriginList?: IFormSelectOption[] = null;
  incomeLevelsList?: IFormSelectOption[] = null;
  executionModeList?: IFormSelectOption[] = null;
  operationExecutionModeList?: IFormSelectOption[] = null;
  presenceInExternalList?: IFormSelectOption[] = null;
  productCategoriesList?: IFormSelectOption[] = null;
  riscattoTypesList?: IFormSelectOption[] = null;
  versamentoTypesList?: IFormSelectOption[] = null;
  documentReleaseAuthorities: IFormSelectOption[] = null;
  documentTypesDomain: IFormSelectOption[] = null;
  professionsList: IFormSelectOption[] = null;
  incomeBracketsList: IFormSelectOption[] = null;
  beneficiariesClassification: IFormSelectOption[] = null;
  businessTypes: IFormSelectOption[] = null;
  relazioneContraenteBeneficiario?: IFormSelectOption[] = null;
  relazioneContraenteAssicurato?: IFormSelectOption[] = null;
  relazioneContraenteEsecutore?: IFormSelectOption[] = null;
  tipoDelega: IFormSelectOption[] = null;
  activeFunds: IPolicyAsset[] = null;
  investmentFunds: IPolicyAsset[] = null;
  funds: IPolicyAsset[] = null;
  policyAssets: IPolicyAsset[];
  firstStepFormTouched: boolean = false;
  lines: IInvestmentLine[] = null;
  operationCost: string = null;
  operationEffectDate: string = null;
  rebalancedLine: IInvestmentLine = null;
  frequenciesList: IFormSelectOption[] = null;
  currentInstallmentAmount?: string = null;
  currentFrequency?: string = null;
  currentEmployersData?: EmployerTableRow[] = null;
  currentBranchOffice: string = null;
  chargeTypes: IFormSelectOption[] = null;
  operationPurposeList: IFormSelectOption[] = null;
  describeExtraData: any = null;
  redemptionTypes: string[] = null;

  movementId: string = null;
  operationStatus: TDashboardStatus = null;
  operationsNamesList: IOperationFilter[] = null;
  selectedIndex: number = 0;
  loadingCompleted: boolean = false;
  loadingStepperCompleted: boolean = false;
  beneficiariesList: ILifeDeathBeneficiary[];
  beneficiariesListPrevidential: IBeneficiarioPrevidenziale[];
  previdentialBeneficiariesList: IBeneficiarioPrevidenziale[] = [];
  previdentialBeneficiariesTypes: IPrevidentialBeneficiaryType[] = [];
  thirdParty: IPersonDataIsv;
  isThirdPartyValid: boolean = false;
  documentsList: any[];
  tableValues: any[] = [];
  companyCode: EPolicyCompany = EPolicyCompany.ISV;
  isPrevidentialPolicy: boolean;
  retirementDate: string = null;
  newRetirementDate: string = null;
  debitDate: string = null;
  effectDate: string = null;
  newContractorData: any = null;
  newContractorSearched: boolean = false;
  iscritto: string = null;
  figureAnagrafiche: IFigureAnagrafiche[] = [];
  payerToUpdate: any;
  payersList: IPagatore[] = [];
  previousDocuments: IDocumentUpdate[] = [];
  presetValid: boolean = true;
  selectedRedemptionType: string = 'NonDefinito'
  hasErrored: boolean = false;

  simulateOperation: boolean = false;

  destroy$: Subject<void> = new Subject<void>();

  constructor(
    private readonly _policyService: PolicyService,
    private readonly _isvService: IsvService,
    private readonly _dashboardService: DashboardService,
    private readonly _dialog: MatDialog,
    private readonly _router: Router,
    private readonly _spinner: SpinnerService,
    private readonly _alertService: AlertService,
    private readonly _location: Location,
    private readonly _authService: AuthenticationService
  ) {}

  // region LIFECYCLE

  ngOnInit(): void {
    const state = history.state;
    LoggerService.logInfo(this.constructor.name, 'state', state);
    this.simulateOperation = CommonUtils.checkAndGet(this._location.getState(), 'simulateOperation', null);
    this.checkIsPermittedOperation(state.element);
  }

  ngAfterViewChecked(): void {
    if (!this.loadingStepperCompleted) {
      if (this.isvStepper) {
        this.manageStepper();
        this.loadingStepperCompleted = true;
      }
      window.scrollTo(
        0,
        window.document.body.scrollHeight - window.innerHeight
      );
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem('movementId');
    this._policyService.detailLoaded(null);
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  // endregion

  checkIsPermittedOperation(element: IDashboardOperation): void {
    const operationObj: IPolicyOperation = this._policyService.operations?.find(operation => operation.operationCode === this._policyService.operationId);
    this.isOperationPermitted = (operationObj?.isPermitted ?? true) ||
        this.isPrevidentialPolicy ||
        ((element?.status === EDashboardStatus.COMPLETED ||
        element?.status === EDashboardStatus.TO_UPLOAD) && element?.movementId !== null);

    if (this.isOperationPermitted) {
      this.watchDetail();
      this.manageDocs();
    } else {
      const prefix = this.isSimulatedOperation ? 'Simulazione ' : 'Operazione ';
      const messageObj = ISV_OPERATION_NOT_PERMITTED_MSG.find(
          (obj) => obj.code === operationObj.notPermittedReason
        );
      let message = messageObj?.message;
      if (!message) {
        message = 'non permessa';
      }
      this.openBackToPolicyModal(prefix + message);
      return;
    }
  }

  watchDetail(): void {
    this._policyService.detailLoadedObs
    .pipe(takeUntil(this.destroy$))
    .subscribe((detailLoaded: boolean) => {
      if (detailLoaded) {
        this.createFormGroups();
        const state = this._location.getState();
        if (state) {
          this.movementId = CommonUtils.checkAndGet(state, 'element.movementId', null);
          if (localStorage.getItem('movementId')) {
            this.movementId = localStorage.getItem('movementId');
          }
          else {
            localStorage.setItem('movementId', this.movementId);
          }
          this.getDraft();
        }
      }
    });
  }

  manageInsuredStatus(): void {
    this.openCheckInsuredModal()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (modalResponse) => {
          if (modalResponse === EModalOutput.NO) {
            this.openBackToPolicyModal(INSURED_NOT_ALIVE_MSG);
          } else {
            const isBeneficiaryEqualToHolder = CommonUtils.checkAndGet(
              this._policyService.policyDetail,
              'intesaFurtherDetails.uni20.isBeneficiaryEqualToHolder',
              false
            );
            if (this._policyService.operationId === '10' && !isBeneficiaryEqualToHolder) {
                this.manageBeneficiaryCoincidenceWithHolderStatus();
            } else {
                this.manageTutorModal(null, !this.cannotCallFormFields, true);
            }
          }
        },
      });
  }

  manageBeneficiaryCoincidenceWithHolderStatus(): void {
    this.openCheckBeneficiaryCoincidenceWithHolderModal()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (modalResponse) => {
          if (modalResponse === EModalOutput.NO) {
            this.openBackToPolicyModal(HOLDER_NOT_REDEEMING_MSG);
          } else {
            this.manageTutorModal(null, !this.cannotCallFormFields, true);
          }
        },
      });
  }


  manageTutorModal(
    draftResponse?: IDraft,
    shouldCallFormFields?: boolean,
    canOverWriteFunds?: boolean
  ): void {
    this._spinner.show();
    const operationsNames$: Observable<IOperationFilter[]> =
      this._dashboardService.retrieveOpDomain(
        CommonUtils.checkAndGet(
          this._policyService.policyDetail,
          'summary.companyCode',
          null
        )
      );
    const idAnagrafico =
      this._policyService.policyDetail?.intesaFurtherDetails.uni30?.policyHolder
        ?.idAnagrafico;
    let isvFormInfo$: Observable<IIntesaFormFieldsResponse> = of(null);
    if (shouldCallFormFields) {
      isvFormInfo$ = this._isvService.retrieveIsvFormInfo(
        this.operationId,
        this.policyId,
        this._policyService.contractNumber,
        draftResponse?.operationState,
        idAnagrafico
      );
    }
    let iban$: Observable<IIbanObject[]> = of(null);
    if (this.canSelectIban) {
      iban$ = this._policyService.retrieveIbanList(this._policyService.contractNumber);
    }
    let ndg$: Observable<IAnagrafica[]> = of(null);
    if (this.isContractorLegalSubject && this.canChangeNdg) {
      if (CommonUtils.isVoid(draftResponse?.draft)) {
        this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(
          ndg_variation_form_template,
          ndg_variation_form_validators
        );
        this.customerHasTutor = true;
      }
      ndg$ = this._policyService.retrieveNdgList(this._policyService.contractNumber);
      this.manageOperationsResponses(
        ndg$,
        iban$,
        operationsNames$,
        isvFormInfo$,
        canOverWriteFunds,
        draftResponse?.draft
      );
    } else if (
      this.canChangeNdg &&
      !this.isContractorLegalSubject &&
      CommonUtils.isVoid(draftResponse?.draft)
    ) {
      this._spinner.hide();
      this.openCheckTutorModal()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (modalResponse) => {
            ndg$ = of(modalResponse);
            this.manageOperationsResponses(
              ndg$,
              iban$,
              operationsNames$,
              isvFormInfo$,
              canOverWriteFunds,
              draftResponse?.draft
            );
          },
        });
    } else {
      this.manageOperationsResponses(
        ndg$,
        iban$,
        operationsNames$,
        isvFormInfo$,
        canOverWriteFunds,
        draftResponse?.draft
      );
    }
    if ([null, 'DRAFT'].includes(this.operationStatus)) {
      this.updateDraft(EDashboardStatus.DRAFT, 0);
    }
  }

  manageOperationsResponses(
    ndg$: Observable<IAnagrafica[]>,
    iban$: Observable<IIbanObject[]>,
    operationsNames$: Observable<IOperationFilter[]>,
    isvFormInfo$: Observable<IIntesaFormFieldsResponse>,
    canOverWriteFunds: boolean = true,
    draft?: string
  ): void {
    forkJoin({
      ndgResponse: ndg$,
      ibanResponse: iban$,
      operationsNamesResponse: operationsNames$,
      isvFormInfoResponse: isvFormInfo$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (x) => {
          LoggerService.logInfo(
            this.constructor.name,
            'manageOperationsResponses',
            x
          );
          if (x && x.isvFormInfoResponse) {
            const contractorType: string = this._policyService.isLegalSubject
              ? 'Giuridica'
              : 'Fisica';
            let formattedObj = IsvUtils.manageIsvFormInfo(
              x.isvFormInfoResponse,
              contractorType,
              canOverWriteFunds,
            );
            if (this.isPrevidentialPolicy) {
              formattedObj = {
                ...formattedObj,
                ...IsvUtils.manageIsvFormInfoPrevidential(
                  x.isvFormInfoResponse,
                  draft
                ),
              };
            }
            Object.entries(formattedObj).forEach(([key, value]) => {
              if (this.hasOwnProperty(key)) {
                (this as any)[key] = value ?? null;
              }
            });
            if (this.operationDataForm) {
              this.operationDataForm?.get('productCategory')?.setValue(formattedObj.productCategory);
              this.operationDataForm?.get('productCategory')?.disable();
              this.operationDataForm?.get('reportScope')?.setValue(formattedObj.reportScope);
              this.operationDataForm?.get('reportScope')?.disable();
            }
          }
          if (x && x.ndgResponse) {
            const collegamenti =
              x.ndgResponse?.['ns2:listaCollegamenti']?.['ns2:collegamenti'];
            const collegamentiAsArray = Array.isArray(collegamenti) ? collegamenti : [collegamenti];
            this.ndgVariationList = collegamentiAsArray.filter(c => {
                return COD_COLLEGAMENTI_ATTIVI_AMMESSI.includes(c?.['ns2:codiceCollegamento'])
            });
          }
          if (x && x.ibanResponse) {
            this.ibansList = x.ibanResponse;
          }
          if (x && x.operationsNamesResponse) {
            this.operationsNamesList = x.operationsNamesResponse;
          }
          this.loadingCompleted = true;
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(
            this.constructor.name,
            'manageOperationsResponses',
            error
          );
          const message: string = CommonUtils.checkAndGet(error, 'error.response.description', CommonUtils.checkAndGet(error, 'error.description', "Errore nel recupero delle info dell'operazione"))
          this._alertService.openErrorMessage(
            message,
            'manageOperationsResponses',
            error
          );
          this._spinner.hide();
        },
      });
  }

  onTutorSelection(subject: IAnagrafica): void {
    this.searchedTutor = CommonUtils.assign(subject);
    LoggerService.logInfo(this.constructor.name, 'onTutorSelection', this.searchedTutor);
  }

  onBeneficiariesUpdate(beneficiariesList: ILifeDeathBeneficiary[]): void {
    LoggerService.logInfo(this.constructor.name, 'onBeneficiariesUpdate', {
      beneficiariesList,
    });
    this.beneficiariesList = CommonUtils.assign(beneficiariesList);
  }

  onPayerUpdate(payer: any): void {
    LoggerService.logInfo(this.constructor.name, 'onPayerUpdate', {
      payer,
    });
    this.payerToUpdate = CommonUtils.assign(payer);
  }

  onBeneficiariesUpdatePrevidential(
    beneficiaries: IBeneficiarioPrevidenziale[]
  ): void {
    LoggerService.logInfo(
      this.constructor.name,
      'onBeneficiariesUpdatePrevidential',
      { beneficiaries }
    );
    this.previdentialBeneficiariesList = beneficiaries;
  }

  onThirdPartyUpdate(thirdPartyData: {
    data: IPersonDataIsv;
    isValid: boolean;
  }): void {
    this.thirdParty = CommonUtils.assign(thirdPartyData?.data);
    this.isThirdPartyValid = thirdPartyData?.isValid;
  }

  onContractorSearch(taxOrVatCode: string): void {
    if (taxOrVatCode) {
      this.onContractorReset();
      this._spinner.show();
      this._isvService
        .searchSubjectByTaxCode(taxOrVatCode, this._policyService.contractNumber)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            LoggerService.logInfo(
              this.constructor.name,
              'onSearchClick',
              response
            );
            this.newContractorData = CommonUtils.assign(response?.subjects[0]);
            this.newContractorSearched = true;
            this.initializeNewContractorForms();
            this._spinner.hide();
          },
          error: (err) => {
            LoggerService.logError(this.constructor.name, 'onSearchClick', err);
            this._alertService.openErrorMessage(
              'Errore durante la ricerca del soggetto',
              err
            );
            this._spinner.hide();
          },
        });
    }
  }

  onContractorReset(): void {
    LoggerService.logInfo(this.constructor.name, 'onContractorReset');

    this.newContractorData = CommonUtils.assign(null);
    this.newContractorSearched = CommonUtils.assign(false);

    this.contractorRegistryForm?.reset();
    this.contractorResidenceForm?.reset();
    this.contractorAddressForm?.reset();
    this.contractorIdentificationDocumentForm?.reset();
    this.contractorBusinessForm?.reset();
    this.newContractorProperVerificationForm?.reset();
    this.newContractorConsentsForm?.reset();
  }

  onLegalGuardianSearch(legalGuardian: any): void {
    LoggerService.logInfo(
      this.constructor.name,
      'onLegalGuardianSearch',
      legalGuardian
    );
    this.searchedLegalGuardian = CommonUtils.assign(legalGuardian);
    this.initializeVCONTLegalGuardianForms();
  }

  checkTariffazione(): void {
    this._spinner.show();
    const body = this.getPayloadForTariffazione();
    this._isvService
      .checkTariffazione(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(
            this.constructor.name,
            'checkTariffazione',
            response
          );
          if (this.operationId === '_RISPA') {
              this.next();
          } else {
            this.confirmOperation();
          }
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(
            this.constructor.name,
            'checkTariffazione',
            error
          );
          let errorMessage = CommonUtils.checkAndGet(
              error,
              'error.response.description',
              "Errore in fase di tariffazione dell'operazione"
          );
          if (this.isPrevidentialPolicy) {
            errorMessage = CommonUtils.checkAndGet(
                error,
                'error.description',
                "Errore in fase di tariffazione dell'operazione"
            );
          }
          this._alertService.openErrorMessage(
              errorMessage,
              'checkTariffazione',
              error
          );
          this._spinner.hide();
        },
      });
  }

  perfezionareTariffazione(): void {
    this._spinner.show();
    const body = this.getPayloadForTariffazione();
    this._isvService
      .perfezionareTariffazione(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(
            this.constructor.name,
            'perfezionareTariffazione',
            response
          );
          this.confirmOperation();
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(
            this.constructor.name,
            'perfezionareTariffazione',
            error
          );
          let errorMessage = CommonUtils.checkAndGet(
              error,
              'error.response.description',
              "Errore in fase di tariffazione dell'operazione"
          );
          if (this.isPrevidentialPolicy) {
            errorMessage = CommonUtils.checkAndGet(
                error,
                'error.description',
                "Errore in fase di tariffazione dell'operazione"
            );
          }
          this._alertService.openErrorMessage(
              errorMessage,
              'perfezionareTariffazione',
              error
          );
          this._spinner.hide();
        },
      });
  }

  confirmOperation(): void {
    this._spinner.show();
    const body = this.getPayloadForOperation();
    this._isvService
      .confirmOperation(body, this.operationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(
            this.constructor.name,
            'confirmOperation',
            response
          );
          if (response) {
            this.manageConfirmOperationResponse(response);
          }
          this._dashboardService.triggerPendingOperations();
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(
            this.constructor.name,
            'confirmOperation',
            error
          );
          if (error.status === 504) {
            this.openWaitingOperationModal();
          } else {
            // This shouldn't be needed: The draft is already in "DRAFT", and the stepper is not incremented until 200 is received
            // let stepperIndex = this.isvStepper.selectedIndex;
            // stepperIndex = stepperIndex - 1;
            // this.updateDraft(EDashboardStatus.DRAFT, stepperIndex);

            let errorMessage = CommonUtils.checkAndGet(
                error,
                'error.response.description',
                "Errore in fase di conferma dell'operazione"
            );
            if (this.isPrevidentialPolicy) {
            errorMessage = CommonUtils.checkAndGet(
                error,
                'error.description',
                "Errore in fase di conferma dell'operazione"
            );
            }
            this._alertService.openErrorMessage(
                errorMessage,
                'confirmOperation',
                error
            );
          }
          this._spinner.hide();
        },
      });
  }

  getPayloadForTariffazione(): any {
    let body: any = null;
    if (!this.isPrevidentialPolicy) {
        switch (this.operationId) {
            case '_VAGG':
                body = IsvUtils.getPayloadForAdditionalPaymentTariffazione(
                    this.policyId,
                    this.operationId,
                    this.firstStepForm?.getRawValue(),
                    this.operationDataForm?.getRawValue(),
                    this.firstStepForm?.get('iban')?.value,
                    this.ibansList,
                    this.activeFunds,
                    CommonUtils.checkAndGet(
                    this._policyService.policyDetail,
                    'policyValue.insuredAmount',
                    null
                    )
                );
                break;
            case '_RISPA':
                body = IsvUtils.getPayloadForRiscattoParzialeTariffazione(
                    this.policyId,
                    this.operationId,
                    this.firstStepForm?.getRawValue(),
                    this.activeFunds,
                    this.selectedRedemptionType
                );
                break;
            default:
                break;
        }
        LoggerService.logInfo(
            this.constructor.name,
            'getPayloadForTariffazione',
            body
        );
        return {
          ...body,
          contractNumber: this._policyService.contractNumber
        };
    }
  }

  getPayloadForOperation(): any {
    let body: any = null;
    switch (this.operationId) {
      case '_VCBMU':
        if (this.isPrevidentialPolicy) {
          body = IsvUtils.getPayloadForVariazioneModalitaPagamento(
            this.ibansList,
            this.firstStepForm?.getRawValue(),
            this.policyId
          );
        } else {
          body = IsvUtils.getPayloadBankAccountChange(
            this.policyId,
            this.firstStepForm?.getRawValue(),
            this.ibansList
          );
        }
        break;
      case '_VAGG':
        if (this.isPolicyPrevidenziale) {
          body = IsvUtils.getPayloadForAdditionalPaymentPrev(
            this.policyId,
            this.firstStepForm?.getRawValue(),
            this.ibansList
          );
        } else {
          body = IsvUtils.getPayloadForAdditionalPayment(
            this.policyId,
            this.firstStepForm?.getRawValue(),
            this.contractorRegistryForm?.getRawValue(),
            this.contractorIdentificationDocumentForm?.getRawValue(),
            this.contractorBusinessForm?.getRawValue(),
            this.contractorResidenceForm?.getRawValue(),
            this.contractorAddressForm?.getRawValue(),
            this.insuredForm?.getRawValue(),
            this.operationDataForm?.getRawValue(),
            this.operatorDataForm?.getRawValue(),
            this.beneficiaryForm?.getRawValue(),
            this.effectiveOwnersList,
            this.legalGuardianRegistryForm?.getRawValue(),
            this.legalGuardianResidenceForm?.getRawValue(),
            this.legalGuardianIdentificationDocumentForm?.getRawValue(),
            this.firstStepForm?.get('iban')?.value,
            this.ibansList,
            this.activeFunds,
            this.ndgTutoreODelegato,
            CommonUtils.checkAndGet(
              this._policyService.policyDetail,
              'policyValue.insuredAmount',
              null
            ),
            this.agreementPurposeList,
            this.effectDate
          );
        }
        break;
      case '_INPAG':
      case '_RIAPU':
        body = IsvUtils.getPayloadForPremiumPaymentSuspension(
          this.policyId,
          this.firstStepForm?.getRawValue()
        );
        break;
      case '_VPRFR':
        body = IsvUtils.getPayloadForPremiumVariation(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this.additionalForm?.getRawValue(),
          this.isPolicyPrevidenziale,
          CommonUtils.checkAndGet(
            this._policyService.policyDetail,
            'summary.productCode',
            null
          )
        );
        break;
      case 'INT_002': // variazione documento
        body = IsvUtils.getPayloadForDocumentChange(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this._policyService.isDetailPrevidenziale,
          this._policyService.policyDetail.intesaFurtherDetails?.uni30
            ?.policyHolder?.idAnagrafico
        );
        break;
      case 'INT_001': // variazione filiale
        body = IsvUtils.getPayloadForBranchOfficeChange(
          this.policyId,
          this.firstStepForm?.getRawValue()
        );
        break;
      case 'INT_003': // rettifica anagrafica
        body = IsvUtils.getPayloadForRegistryAdjustment(
          this.policyId,
          this.firstStepForm?.getRawValue()
        );
        break;
      case '_VBENE': // variazione beneficiario vita/morte
        if (this.isPrevidentialPolicy) {
          body = IsvUtils.getPayloadForBeneficiaryChangePrevidential(
            this.policyId,
            this.previdentialBeneficiariesList,
            this.firstStepForm.getRawValue()
          );
        } else {
          body = IsvUtils.getPayloadForBeneficiaryChange(
            this.policyId,
            this.beneficiariesList,
            this.thirdParty
          );
        }
        break;
      case 'INT_004':
        body = IsvUtils.getPayloadForPayerVariation(
          this.policyId,
          this.payerToUpdate
        );
        break;
      case 'INT_005': // variazione data addebito
        body = IsvUtils.getPayloadDebitDateVariation(
          this.policyId,
          this.firstStepForm?.getRawValue()
        );
        break;
      case 'INT_006': // variazione data pensionamento
        body = IsvUtils.getPayloadRetirementDateVariation(
          this.policyId,
          this.firstStepForm?.getRawValue()
        );
        break;
      case '_VRECP': // variazione recapito
      case '69': // variazione residenza
        body = IsvUtils.getPayloadForResidenceChange(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this.contractorTypeDescription,
          this.iscritto,
          this.figureAnagrafiche
        );
        break;
      case '_SIMOR': // comunicazione sinistro
        body = IsvUtils.getPayloadForComunicazioneSinistro(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this.additionalForm?.getRawValue(),
          this._policyService.policyHolderIntesa
        );
        break;
      case '_SWITR': // Switch Fondi
        if (this.isPolicyPrevidenziale) {
          body = IsvUtils.getPayloadForSwitchInvestmentPrevidenziale(
            this.policyId,
            this.firstStepForm?.getRawValue(),
            this.activeFunds,
            this.investmentFunds
          );
        } else {
          body = IsvUtils.getPayloadForSwitchInvestment(
            this.policyId,
            this.ndgTutoreODelegato,
            this.firstStepForm?.getRawValue(),
            this.activeFunds,
            this.investmentFunds,
            CommonUtils.checkAndGet(
              this._policyService.policyDetail,
              'policyValue.insuredAmount',
              null
            )
          );
        }
        break;
      case '_SWITC': // Variazione linea Investimento
        if (this.isPolicyPrevidenziale) {
          body = IsvUtils.getPayloadForChangeInvestmentLinePrevidential(
            this.policyId,
            this.firstStepForm?.getRawValue(),
            this.lines,
            CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'summary.emissionDate',
                null
              ),

            CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'summary.expiryDate',
                null
              )
          );
        } else {
            body = IsvUtils.getPayloadForChangeInvestmentLine(
              this.policyId,
              this.ndgTutoreODelegato,
              this.firstStepForm?.getRawValue(),
              this.lines,
              CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'policyValue.insuredAmount',
                null
              )
            );
        }
        break;
      case 'VU': // Ribilanciamento
        body = {
          policyNumber: this.policyId,
        };
        break;
      case 'INT_008': // Reindirizzamento Fondi
        body = IsvUtils.getPayloadForReindirizzamentoFondi(
            this.policyId,
            this.investmentFunds,
            CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'summary.emissionDate',
                null
              ),
            CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'summary.expiryDate',
                null
              )
        );
        break;
      case '_ANAPP': // annullo operazione
        body = IsvUtils.getPayloadForAnnulloOperazione(
          this.policyId,
          this.movementId
        );
        break;
      case '_RISTO': // riscatto totale
        body = IsvUtils.getPayloadForRiscattoTotale(
          this.policyId,
          this.contractorRegistryForm?.getRawValue(),
          this.contractorIdentificationDocumentForm?.getRawValue(),
          this.contractorBusinessForm?.getRawValue(),
          this.contractorResidenceForm?.getRawValue(),
          this.contractorAddressForm?.getRawValue(),
          this.insuredForm?.getRawValue(),
          this.operationDataForm?.getRawValue(),
          this.operatorDataForm?.getRawValue(),
          this.beneficiaryForm?.getRawValue(),
          this.effectiveOwnersList,
          this.legalGuardianRegistryForm?.getRawValue(),
          this.legalGuardianResidenceForm?.getRawValue(),
          this.legalGuardianIdentificationDocumentForm?.getRawValue(),
          this.ndgTutoreODelegato,
          CommonUtils.checkAndGet(
            this._policyService.policyDetail,
            'policyValue.funds',
            null
          ),
          CommonUtils.checkAndGet(
            this._policyService.policyDetail,
            'policyValue.insuredAmount',
            null
          ),
          this.firstStepForm?.get('iban')?.value,
          this.ibansList,
          this.agreementPurposeList,
          this.firstStepForm?.get('fiscalRegime')?.value,
          this.describeExtraData
        );
        break;
      case '10': // liquidazione a scadenza
        body = IsvUtils.getPayloadForLiquidazioneScadenza(
          this.policyId,
          this.contractorRegistryForm?.getRawValue(),
          this.contractorIdentificationDocumentForm?.getRawValue(),
          this.contractorBusinessForm?.getRawValue(),
          this.contractorResidenceForm?.getRawValue(),
          this.contractorAddressForm?.getRawValue(),
          this.insuredForm?.getRawValue(),
          this.operationDataForm?.getRawValue(),
          this.operatorDataForm?.getRawValue(),
          this.beneficiaryForm?.getRawValue(),
          this.effectiveOwnersList,
          this.legalGuardianRegistryForm?.getRawValue(),
          this.legalGuardianResidenceForm?.getRawValue(),
          this.legalGuardianIdentificationDocumentForm?.getRawValue(),
          CommonUtils.checkAndGet(
            this._policyService.policyDetail,
            'policyValue.insuredAmount',
            null
          ),
          this.firstStepForm?.get('iban')?.value,
          this.ibansList,
          this.agreementPurposeList,
          this.effectDate
        );
        break;
      case '_RISPA': // riscatto parziale
        body = IsvUtils.getPayloadForRiscattoParziale(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this.contractorRegistryForm?.getRawValue(),
          this.contractorIdentificationDocumentForm?.getRawValue(),
          this.contractorBusinessForm?.getRawValue(),
          this.contractorResidenceForm?.getRawValue(),
          this.contractorAddressForm?.getRawValue(),
          this.insuredForm?.getRawValue(),
          this.operationDataForm?.getRawValue(),
          this.operatorDataForm?.getRawValue(),
          this.beneficiaryForm?.getRawValue(),
          this.effectiveOwnersList,
          this.legalGuardianRegistryForm?.getRawValue(),
          this.legalGuardianResidenceForm?.getRawValue(),
          this.legalGuardianIdentificationDocumentForm?.getRawValue(),
          this.firstStepForm?.get('iban')?.value,
          this.ibansList,
          this.activeFunds,
          this.ndgTutoreODelegato,
          this.agreementPurposeList,
          this.selectedRedemptionType,
          this.describeExtraData
        );
        break;
      case 'INT_010':
        body = IsvUtils.getPayloadForSpostamentoIscritto(
          this.policyId,
          this.currentEmployersData
        )
        break;
      case '_VCONT': // variazione contraenza
        const policyHolderType =
          'partitaIva' in this.policyHolderData ? 'G' : 'F';
        body = IsvUtils.getPayloadForCessioneContraenza(
          this.policyId,
          this.firstStepForm?.getRawValue(),
          this.contractorRegistryForm?.getRawValue(),
          this.contractorIdentificationDocumentForm?.getRawValue(),
          this.contractorBusinessForm?.getRawValue(),
          this.contractorResidenceForm?.getRawValue(),
          this.contractorAddressForm?.getRawValue(),
          this.insuredForm?.getRawValue(),
          this.operationDataForm?.getRawValue(),
          this.operatorDataForm?.getRawValue(),
          this.beneficiaryForm?.getRawValue(),
          this.effectiveOwnersList,
          this.legalGuardianRegistryForm?.getRawValue(),
          this.legalGuardianResidenceForm?.getRawValue(),
          this.legalGuardianIdentificationDocumentForm?.getRawValue(),
          this.newContractorProperVerificationForm?.getRawValue(),
          this.newContractorConsentsForm?.getRawValue(),
          this.additionalForm?.getRawValue(),
          this.legalGuardianProperVerificationForm?.getRawValue(),
          this.holderBeneficiaryRelationshipList,
          policyHolderType,
          this.chargeTypes,
          this.agreementPurposeList
        );
        break;
      default:
        break;
    }
    LoggerService.logInfo(
      this.constructor.name,
      'getPayloadForOperation',
      body
    );
    return {
      ...body,
      contractNumber: this._policyService.contractNumber
    };
  }

  manageConfirmOperationResponse(response: any): void {
    this.movementId = CommonUtils.checkAndGet(response, 'movementId', null);
    localStorage.setItem('movementId', this.movementId);
    this.operationStatus = EDashboardStatus.TO_UPLOAD;
    if (this.isCancelOperation) {
      this.retrieveCancelDocument();
    }
    this.next();
  }

  async finalizeOperation(): Promise<void> {
    LoggerService.logInfo(this.constructor.name, 'finalizeOperation');
    this._spinner.show();
    this._policyService
      .finalizeOperation(this.policyId, this.operationId, this.movementId, this.isCancelOperation)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.openBackToPolicyModal(
            OP_COMPLETED_MSG,
            'Operazione completata con successo!'
          );
          LoggerService.logInfo(this.constructor.name, 'finalizeOperation', {
            response,
          });
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'finalizeOperation', {
            error,
          });
          this._alertService.openErrorMessage(
            "Errore in fase di finalizzazione dell'operazione",
            'finalizeOperation',
            error
          );
          this._spinner.hide();
        },
      });
  }

  async fileToBase64(file: Blob): Promise<string> {
    const buffer = await file.arrayBuffer();
    const bytes = new Uint8Array(buffer);

    const chunkSize = 0x8000;
    let binary = '';
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize) as any);
    }
    return btoa(binary);
  }

  emittedFunds(funds): void {
    LoggerService.logInfo(this.constructor.name, 'emittedFunds', funds);
    this.funds = funds;
  }

  onSelectedRedemptionType(redeemState: {redemptionType: string, hasErrored: boolean, assets: IPolicyAsset[]}): void {
    LoggerService.logInfo(this.constructor.name, 'onSelectedRedemptionType', redeemState);
    this.selectedRedemptionType = redeemState.redemptionType;
    this.hasErrored = redeemState.hasErrored;
    this.activeFunds = redeemState.assets;
  }

  // region DRAFT

  saveDraft(draft: string) {
    if (this.isHelpDeskAccount) {
      // per gli account HD non deve essere possibile salvare nuove bozze
      return;
    }
    this._spinner.show();
    this._policyService
      .saveDraft(draft, this.operationStatus, this.operationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'saveDraft', {
            response,
          });
          this.operationStatus = CommonUtils.checkAndGet(
            response,
            'entity.operationState',
            null
          );
          this._dashboardService.triggerPendingOperations();
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'saveDraft', { error });
          this._alertService.openErrorMessage('', 'saveDraft', error);
          this._spinner.hide();
        },
      });
  }

  updateDraft(state = EDashboardStatus.DRAFT, index = null, emptyDraft?: string) {
    if (this.isHelpDeskAccount) {
      // per gli account HD non deve essere possibile salvare nuove bozze
      return;
    }
    this.operationStatus = state;
    const effectiveOwnersList = this.effectiveOwnersList.map(
      (owner: IPersonIntestaFormGroups) => {
        return {
          registryForm: owner.registryForm
            ? owner.registryForm.getRawValue()
            : null,
          residenceForm: owner.residenceForm
            ? owner.residenceForm.getRawValue()
            : null,
          identificationDocumentForm: owner.identificationDocumentForm
            ? owner.identificationDocumentForm.getRawValue()
            : null,
          properVerificationForm: owner.properVerificationForm
            ? owner.properVerificationForm.getRawValue()
            : null,
        };
      }
    );
    const draftObj: IDraftItem = {
      firstStepForm: this.firstStepForm?.getRawValue(),
      additionalForm: this.additionalForm?.getRawValue(),
      ndgVariationForm: this.ndgVariationForm?.getRawValue(),
      searchedTutor: this.searchedTutor,
      selectedIndex: index !== null ? index : this.isvStepper.selectedIndex,
      customerHasTutor: this.customerHasTutor,
      beneficiaries: this.beneficiariesList,
      thirdParty: this.thirdParty,
      currentBranchOffice: this.currentBranchOffice,
      effectiveOwnersList: effectiveOwnersList,
      assets: this.policyAssets,
      firstStepFormTouched: this.firstStepForm?.touched,
      contractorRegistryForm: this.contractorRegistryForm?.getRawValue(),
      contractorResidenceForm: this.contractorResidenceForm?.getRawValue(),
      contractorAddressForm: this.contractorAddressForm?.getRawValue(),
      contractorIdentificationDocumentForm:
        this.contractorIdentificationDocumentForm?.getRawValue(),
      newContractorConsentsForm: this.newContractorConsentsForm?.getRawValue(),
      newContractorProperVerificationForm:
        this.newContractorProperVerificationForm?.getRawValue(),
      contractorBusinessForm: this.contractorBusinessForm?.getRawValue(),
      operationDataForm: this.operationDataForm?.getRawValue(),
      operatorDataForm: this.operatorDataForm?.getRawValue(),
      insuredForm: this.insuredForm?.getRawValue(),
      beneficiaryForm: this.beneficiaryForm?.getRawValue(),
      activeFunds: this.activeFunds,
      investmentFunds: this.investmentFunds,
      lines: this.lines,
      rebalancedLine: this.rebalancedLine,
      employersData: this.currentEmployersData,
      newContractorData: this.newContractorData,
      newContractorSearched: this.newContractorSearched,
      searchedLegalGuardian: this.searchedLegalGuardian,
      operationEffectDate: this.operationEffectDate,
      selectedRedemptionType: this.selectedRedemptionType,
      legalGuardianRegistryForm: this.legalGuardianRegistryForm?.getRawValue(),
      legalGuardianResidenceForm: this.legalGuardianResidenceForm?.getRawValue(),
      legalGuardianAddressForm: this.legalGuardianAddressForm?.getRawValue(),
      legalGuardianIdentificationDocumentForm: this.legalGuardianIdentificationDocumentForm?.getRawValue(),
      legalGuardianProperVerificationForm: this.legalGuardianProperVerificationForm?.getRawValue(),
    };
    const draftToSave = emptyDraft ? emptyDraft : draftObj;
    const encodedString = btoa(JSON.stringify(draftToSave));
    LoggerService.logInfo(this.constructor.name, 'updateDraft', {
      draftToSave,
      encodedString,
    });
    this.saveDraft(encodedString);
  }

  private evaluatePoliceCompanyCode(): void {
    this.companyCode = CommonUtils.checkAndGet(
      this._policyService.policyDetail,
      'summary.companyCode',
      null
    );
    this.isPrevidentialPolicy =
      this.companyCode && EPolicyCompany.ISP.includes(this.companyCode);
  }

  getDraft(): void {
    if (this.isCancelOperation) {
      this.loadingCompleted = true;
      return;
    }
    this._spinner.show();
    this._policyService.getDraft(this.movementId, this.isSimulatedOperation)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (draftResponse: IDraft) => {
          LoggerService.logInfo(
            this.constructor.name,
            'getDraft',
            draftResponse
          );
          if (
            draftResponse &&
            draftResponse.draft &&
            draftResponse.operationCode
          ) {
            // è presente un'operazione in draft per la polizza corrente
            this._spinner.hide();
            const check = draftResponse.operationCode.includes(
              this._policyService.operationId
            );
            this.evaluatePoliceCompanyCode();
            if (check) {
              // l'operazione selezionata coincide con il draft recuperato
              this.manageExistingOperation(draftResponse);
            } else {
              // l'operazione selezionata non coincide con il draft recuperato
              // (si sta tentando di iniziare un'operazione diversa dal draft corrente)
              this.openBackToPolicyModal(DIFFERENT_OP_DRAFT_MSG);
              return;
            }
          } else {
            // non sono presenti operazioni in draft oppure esiste un draft vuoto
            this._spinner.hide();
            this.evaluatePoliceCompanyCode();
            if (!this.isPrevidentialPolicy) {
              this.operationStatus = CommonUtils.checkAndGet(
                draftResponse,
                'operationState',
                null
              );
              this.beneficiariesList = CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'intesaFurtherDetails.uni20.policybeneficiaries',
                []
              );
              const policyFunds = CommonUtils.checkAndGet(
                this._policyService.policyDetail,
                'policyValue.funds',
                null
              );
              if (policyFunds) {
                this.policyAssets = policyFunds.map((fund) => ({
                  attributeDescription: fund.description,
                  amount: '0',
                  percentage: fund.percentage,
                }));
              }
            }
            this.manageNewOperationDraft(draftResponse);
          }
        },
        error: (draftError) => {
          LoggerService.logError(this.constructor.name, 'getDraft', draftError);
          const status: number = CommonUtils.checkAndGet(
            draftError,
            'status',
            null
          );
          let message: string =
            status === 403 ? 'Non è possibile operare su questa polizza' : '';
          this._alertService.openErrorMessage(message, 'getDraft', draftError);
          this._spinner.hide();
        },
      });
  }

  retrieveDraftStatus(): Observable<boolean> {
      return this._policyService.getDraft(this.movementId, this.isSimulatedOperation).pipe(
        take(1),
        map((response: IDraft) => {
          if (response) {
            return response.operationState !== 'DRAFT';
          }
          return false;
        }),
        catchError((error: any) => {
          LoggerService.logError(this.constructor.name, 'retrieveDraftStatus', { error });
          this._alertService.openErrorMessage("Errore nel recupero dello stato della bozza", 'retrieveDraftStatus', error);
          return of(false);
        })
      );
    }

  manageExistingOperation(draftResponse: IDraft): void {
    const decodedString: string = atob(draftResponse.draft);
    const obj: IDraftItem = JSON.parse(decodedString);
    if (obj) {
      this.patchFormsFromDraft(obj);
      this.patchObjectsFromDraft(draftResponse, obj);
      if (this.isReadOnly) {
        this.disableAllForms();
      }
    }
    this.manageTutorModal(
      draftResponse,
      this.shouldCallFromFields(obj),
      this.canOverWriteFunds(obj)
    );
  }

  shouldCallFromFields(draftObj: IDraftItem): boolean {
    switch (this.operationId) {
      case '_SWITR':
      case 'INT_008':
        return !draftObj?.activeFunds && !draftObj?.investmentFunds;
      case '_VCBMU':
        if (this.isPrevidentialPolicy) return false;
        else return true;
      default:
        return true;
    }
  }

  canOverWriteFunds(draftObj: IDraftItem): boolean {
    switch (this.operationId) {
      case '_RISPA':
      case '_VAGG':
        return !draftObj?.activeFunds;
      default:
        return true;
    }
  }

  manageNewOperationDraft(draftResponse: IDraft): void {
    let errorMessage: string = null;
    if (!this.canOperateToday) {
      // se è già stata completata un'operazione in data corrente allora non può essere creato un nuovo draft
      errorMessage = DIFFERENT_OP_COMPLETED_MSG;
    }
    const opCodeFromDraft = CommonUtils.checkAndGet(
      draftResponse,
      'operationCode',
      null
    );
    if (opCodeFromDraft && opCodeFromDraft !== this.operationId) {
      // se è presente un draft vuoto su un'altra operazione allora non può essere creato un nuovo draft
      errorMessage = DIFFERENT_OP_DRAFT_MSG;
    }
    if (this._policyService.isDetailPrevidenziale) {
      const movementsList = this._policyService.transactionList;
      if (movementsList && Array.isArray(movementsList)) {
        const today = moment().format('YYYY-MM-DD');
        const found = movementsList.some((movement) => {
          const movementDate = moment(movement.operationDate).format('YYYY-MM-DD');
          return (
          movementDate === today &&
          movement.operationId === this.operationId &&
          movement.status === EDashboardStatus.COMPLETED
          );
        });
        if (found) {
          errorMessage = SAME_OP_COMPLETED_MSG;
        }
      }
    }
    if (errorMessage) {
      this.openBackToPolicyModal(errorMessage);
      return;
    }
    if (
      this.hasInsuredCheck &&
      !opCodeFromDraft &&
      !this.isPrevidentialPolicy
    ) {
      this.manageInsuredStatus();
    } else {
      this.manageTutorModal(draftResponse, !this.cannotCallFormFields);
    }
  }

  patchFormsFromDraft(draftObj: IDraftItem): void {
    LoggerService.logInfo(
      this.constructor.name,
      'patchFormFromDraft',
      draftObj
    );
    if (draftObj.firstStepForm) {
      FormUtils.patchFormFromObject(draftObj.firstStepForm, this.firstStepForm);
    }
    if (this.operationId === '_VCONT') {
      const isLegalGuardianPresent = draftObj.searchedLegalGuardian ? true : false;
      this.initializeNewContractorForms(isLegalGuardianPresent);
    }
    if (draftObj.additionalForm) {
        if (this.operationId === '_SIMOR') {
            // Add missing controls then patch values
            Object.keys(draftObj.additionalForm).forEach(key => {
                if (!this.additionalForm.contains(key)) {
                    this.additionalForm.addControl(key, new FormControl(''));
                }
            });
            this.additionalForm.patchValue(draftObj.additionalForm);
        }
      FormUtils.patchFormFromObject(
        draftObj.additionalForm,
        this.additionalForm
      );
    }
    if (draftObj.contractorRegistryForm) {
      FormUtils.patchFormFromObject(
        draftObj.contractorRegistryForm,
        this.contractorRegistryForm
      );
    }
    if (draftObj.contractorResidenceForm) {
      FormUtils.patchFormFromObject(
        draftObj.contractorResidenceForm,
        this.contractorResidenceForm
      );
    }
    if (draftObj.contractorAddressForm) {
      FormUtils.patchFormFromObject(
        draftObj.contractorAddressForm,
        this.contractorAddressForm
      );
    }
    if (draftObj.contractorIdentificationDocumentForm) {
      FormUtils.patchFormFromObject(
        draftObj.contractorIdentificationDocumentForm,
        this.contractorIdentificationDocumentForm
      );
    }
    if (draftObj.contractorBusinessForm) {
      FormUtils.patchFormFromObject(
        draftObj.contractorBusinessForm,
        this.contractorBusinessForm
      );
    }
    if (draftObj.newContractorConsentsForm) {
      FormUtils.patchFormFromObject(
        draftObj.newContractorConsentsForm,
        this.newContractorConsentsForm
      );
    }
    if (draftObj.legalGuardianRegistryForm) {
      FormUtils.patchFormFromObject(
        draftObj.legalGuardianRegistryForm,
        this.legalGuardianRegistryForm
      );
    }
    if (draftObj.legalGuardianResidenceForm) {
      FormUtils.patchFormFromObject(
        draftObj.legalGuardianResidenceForm,
        this.legalGuardianResidenceForm
      );
    }
    if (draftObj.legalGuardianAddressForm) {
      FormUtils.patchFormFromObject(
        draftObj.legalGuardianAddressForm,
        this.legalGuardianAddressForm
      );
    }
    if (draftObj.legalGuardianIdentificationDocumentForm) {
      FormUtils.patchFormFromObject(
        draftObj.legalGuardianIdentificationDocumentForm,
        this.legalGuardianIdentificationDocumentForm
      );
    }
    if (draftObj.legalGuardianProperVerificationForm) {
      FormUtils.patchFormFromObject(
        draftObj.legalGuardianProperVerificationForm,
        this.legalGuardianProperVerificationForm
      );
    }
    if (draftObj.operationDataForm) {
      FormUtils.patchFormFromObject(
        draftObj.operationDataForm,
        this.operationDataForm
      );
    }
    if (draftObj.operatorDataForm) {
      FormUtils.patchFormFromObject(
        draftObj.operatorDataForm,
        this.operatorDataForm
      );
    }
    if (draftObj.insuredForm) {
      FormUtils.patchFormFromObject(draftObj.insuredForm, this.insuredForm);
    }
    if (draftObj.beneficiaryForm) {
      FormUtils.patchFormFromObject(
        draftObj.beneficiaryForm,
        this.beneficiaryForm
      );
    }
    if (draftObj.customerHasTutor) {
      this.customerHasTutor = CommonUtils.checkAndGet(
        draftObj,
        'customerHasTutor',
        null
      );
      this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(
        ndg_variation_form_template,
        ndg_variation_form_validators
      );
      if (draftObj.ndgVariationForm) {
        FormUtils.patchFormFromObject(
          draftObj.ndgVariationForm,
          this.ndgVariationForm
        );
      }
    }
    if (draftObj.effectiveOwnersList) {
      this.effectiveOwnersList = draftObj.effectiveOwnersList.map(
        (owner: IPersonIntestaFormGroups) => {
          return {
            registryForm: FormUtils.initFormGroupFromTemplate(
              owner.registryForm,
              isv_contractor_registry_form_validators
            ),
            residenceForm: FormUtils.initFormGroupFromTemplate(
              owner.residenceForm,
              isv_contractor_residence_form_validators
            ),
            identificationDocumentForm: FormUtils.initFormGroupFromTemplate(
              owner.identificationDocumentForm,
              document_change_form_validators
            ),
            ...( this.operationId === '_VCONT' && {properVerificationForm: FormUtils.initFormGroupFromTemplate(
                owner.properVerificationForm,
                isv_tutor_proper_verification_form_validators
            )})
          };
        }
      );
    }
    if (draftObj.newContractorProperVerificationForm) {
      this.newContractorProperVerificationForm =
        FormUtils.initFormGroupFromTemplate(
          draftObj.newContractorProperVerificationForm,
          proper_verification_form_validators
        );
      Object.keys(draftObj.newContractorProperVerificationForm).forEach(
        (key) => {
          if (!Object.keys(proper_verification_form_validators).includes(key)) {
            this.newContractorProperVerificationForm
              .get(key)
              ?.setValidators(null);
          }
        }
      );
    }
    if (draftObj.newContractorConsentsForm) {
      FormUtils.patchFormFromObject(
        draftObj.newContractorConsentsForm,
        this.newContractorConsentsForm
      );
    }
  }

  patchObjectsFromDraft(draftResponse: IDraft, draftObj: IDraftItem): void {
    this.movementId = CommonUtils.checkAndGet(
      draftResponse,
      'movementId',
      null
    );
    this.operationStatus = CommonUtils.checkAndGet(
      draftResponse,
      'operationState',
      null
    );
    if (draftObj.selectedIndex !== null) {
      this.selectedIndex = draftObj.selectedIndex;
      if (COMPLETED_OPERATION_STATES.includes(this.operationStatus as EDashboardStatus)) {
        this.selectedIndex += 2;
      }
      if (EDashboardStatus.TO_UPLOAD === this.operationStatus) {
        this.selectedIndex += 1;
        if (this.hasDocsToDownload) {
          this.selectedIndex += 1;
        }
      }
    }
    this.currentBranchOffice = CommonUtils.checkAndGet(
      draftObj,
      'currentBranchOffice',
      null
    );
    this.beneficiariesList = CommonUtils.checkAndGet(
      draftObj,
      'beneficiaries',
      null
    );
    this.thirdParty = CommonUtils.checkAndGet(draftObj, 'thirdParty', null);
    this.policyAssets = CommonUtils.checkAndGet(draftObj, 'assets', null);
    this.firstStepFormTouched = CommonUtils.checkAndGet(
      draftObj,
      'firstStepFormTouched',
      false
    );
    if (draftObj?.activeFunds) {
      this.activeFunds = CommonUtils.checkAndGet(draftObj, 'activeFunds', null);
    }
    if (draftObj?.investmentFunds) {
      this.investmentFunds = CommonUtils.checkAndGet(
        draftObj,
        'investmentFunds',
        null
      );
    }
    if (draftObj?.lines) {
      this.lines = CommonUtils.checkAndGet(draftObj, 'lines', null);
    }
    if (draftObj?.rebalancedLine) {
      this.rebalancedLine = CommonUtils.checkAndGet(
        draftObj,
        'rebalancedLine',
        null
      );
    }
    if (draftObj?.searchedTutor) {
      this.searchedTutor = CommonUtils.checkAndGet(
        draftObj,
        'searchedTutor',
        null
      );
      // this.selectedIndex += 1;
    }
    if (draftObj?.operationEffectDate) {
        this.operationEffectDate = CommonUtils.checkAndGet(
          draftObj,
          'operationEffectDate',
          null
        );
    }
    if (this.operationId === '_VCONT') {
      if (draftObj?.newContractorData) {
        this.newContractorData = CommonUtils.checkAndGet(
          draftObj,
          'newContractorData',
          null
        );
        this.contractorRegistryForm?.disable();
        this.contractorRegistryForm?.get('holderRelationship')?.enable();
        this.contractorRegistryForm?.get('comportamentoCliente')?.enable();
        this.contractorRegistryForm?.get('dataNascita')?.enable();
        this.contractorRegistryForm?.get('cittadinanza')?.enable();
      }
      this.searchedLegalGuardian = CommonUtils.checkAndGet(
        draftObj,
        'searchedLegalGuardian',
        null
      );
      this.newContractorSearched = CommonUtils.checkAndGet(
        draftObj,
        'newContractorSearched',
        false
      );
    }
    if (draftObj?.employersData) {
      this.currentEmployersData = CommonUtils.checkAndGet(
        draftObj,
        'employersData',
        null
      );
    }
    if (draftObj?.selectedRedemptionType) {
      this.selectedRedemptionType = CommonUtils.checkAndGet(
        draftObj,
        'selectedRedemptionType',
        null
      );
    }
  }
  // endregion

  // region FORMS

  createFormGroups(): void {
    if (
      this.hasQuestionnaireStep &&
      !this._policyService.isDetailPrevidenziale
    ) {
      if (this.operationId !== '_VCONT') {
        this.initializeContractorForms();
      }
      this.insuredForm = FormUtils.initFormGroupFromTemplate(
        insured_form_template,
        insured_form_validators
      );
    this.initializeOperationDataForm();
      if (this._policyService.isLegalSubject && this.operationId !== '_VCONT') {
        this.initializeLegalGuardianForms();
      }
    }
    this.initializeOperationForm();
  }

  initializeContractorForms(): void {
    const registryFormTemplate = IsvUtils.initializeRegistryFormTemplate(
      this.policyHolderData
    );
    this.contractorRegistryForm = FormUtils.initFormGroupFromTemplate(
      registryFormTemplate,
      isv_contractor_registry_form_validators
    );
    const residenceFormTemplate = this._policyService.isLegalSubject
      ? (this.policyHolderData as ILegalPersonIntesa).indirizzoSedeLegale
      : (this.policyHolderData as IPersonIntesa).datiResidenza;
    this.contractorResidenceForm = FormUtils.initFormGroupFromTemplate(
      residenceFormTemplate,
      isv_contractor_residence_form_validators
    );
    const indirizzoRecapito = CommonUtils.isVoidObj(
      this.policyHolderData.indirizzoRecapito
    )
      ? isv_contractor_address_form_template
      : this.policyHolderData.indirizzoRecapito;
    const addressFormTemplate = {
      ...indirizzoRecapito,
      sameAsResidence: null,
    };
    this.contractorAddressForm = FormUtils.initFormGroupFromTemplate(
      addressFormTemplate,
      isv_contractor_address_form_validators
    );
    if (
      !this._policyService.isLegalSubject &&
      'documentoRiconoscimento' in this.policyHolderData
    ) {
      const idDocumentFormTemplate =
        this.policyHolderData.documentoRiconoscimento;
      this.contractorIdentificationDocumentForm =
        FormUtils.initFormGroupFromTemplate(
          idDocumentFormTemplate,
          document_change_form_validators
        );
    //   this.contractorIdentificationDocumentForm.get('enteRilascio')?.disable();
    }
    const businessFormTemplate = IsvUtils.initializeBusinessFormTemplate(
      this.policyHolderData
    );
    const businessFormValidators = this._policyService.isLegalSubject
      ? isv_PG_contractor_business_form_validators
      : isv_contractor_business_form_validators;
    this.contractorBusinessForm = FormUtils.initFormGroupFromTemplate(
      businessFormTemplate,
      businessFormValidators
    );
    this.insuredForm = FormUtils.initFormGroupFromTemplate(
      insured_form_template,
      insured_form_validators
    );
    this.beneficiaryForm = FormUtils.initFormGroupFromTemplate(
      beneficiary_form_template,
      beneficiary_form_validators
    );
  }

  initializeNewContractorForms(isLegalGuardianPresent?: boolean): void {
    const type = this.firstStepForm?.get('type')?.value;
    const registryFormTemplate =
      IsvUtils.initializeNewContractorRegistryFormTemplate(
        this.newContractorData,
        type
      );
    this.contractorRegistryForm = FormUtils.initFormGroupFromTemplate(
      registryFormTemplate,
      isv_new_contractor_registry_form_validators
    );
    const residenceFormTemplate = {
      stato: this.newContractorData?.fiscalAddress?.CodiceNazione,
      localita: this.newContractorData?.fiscalAddress?.Comune,
      provincia: this.newContractorData?.fiscalAddress?.CodiceProvincia,
      cap: this.newContractorData?.fiscalAddress?.Cap,
      indirizzo: this.newContractorData?.fiscalAddress?.Indirizzo,
    };
    this.contractorResidenceForm = FormUtils.initFormGroupFromTemplate(
      residenceFormTemplate,
      isv_contractor_residence_form_validators
    );
    const addressFormTemplate = {
      stato: this.newContractorData?.contactAddress?.CodiceNazione,
      localita: this.newContractorData?.contactAddress?.Comune,
      provincia: this.newContractorData?.contactAddress?.CodiceProvincia,
      cap: this.newContractorData?.contactAddress?.Cap,
      indirizzo: this.newContractorData?.contactAddress?.Indirizzo,
      sameAsResidence: null,
    };
    this.contractorAddressForm = FormUtils.initFormGroupFromTemplate(
      addressFormTemplate,
      isv_contractor_address_form_validators
    );
    const idDocumentFormTemplate =
      IsvUtils.initializeNewContractorDocumentFormTemplate(
        this.newContractorData
      );
    this.contractorIdentificationDocumentForm =
      FormUtils.initFormGroupFromTemplate(
        idDocumentFormTemplate,
        document_change_form_validators
      );
    // this.contractorIdentificationDocumentForm.get('enteRilascio')?.disable();
    const businessFormTemplate =
      IsvUtils.initializeNewContractorBusinessFormTemplate(
        this.newContractorData,
        type
      );
    this.contractorBusinessForm = FormUtils.initFormGroupFromTemplate(
      businessFormTemplate,
      type === ESpecificBeneficiaryType.PERSONA_FISICA ? isv_new_contractor_business_form_validators : isv_PG_contractor_business_form_validators
    );
    this.newContractorProperVerificationForm =
      FormUtils.initFormGroupFromTemplate(
        proper_verification_form_template,
        proper_verification_form_validators
      );
    if (this.chargeTypes) {
      this.chargeTypes.forEach((chargeType) => {
        this.newContractorProperVerificationForm?.addControl(
          chargeType.key,
          new FormControl(null, null)
        );
      });
    }

    if (isLegalGuardianPresent) {

        const legalGuardianTemplate = IsvUtils.initializeNewContractorRegistryFormTemplate(null, ESpecificBeneficiaryType.PERSONA_FISICA, true);
        this.legalGuardianRegistryForm = FormUtils.initFormGroupFromTemplate(
          legalGuardianTemplate,
          isv_legal_guardian_registry_form_validators
        );
        this.legalGuardianResidenceForm = FormUtils.initFormGroupFromTemplate(
          isv_contractor_residence_form_template,
          isv_contractor_residence_form_validators
        );
        this.legalGuardianAddressForm = FormUtils.initFormGroupFromTemplate(
          isv_contractor_address_form_template,
          isv_contractor_address_form_validators
        );
        this.legalGuardianIdentificationDocumentForm =
          FormUtils.initFormGroupFromTemplate(
            document_change_form_template,
            document_change_form_validators
          );
        this.legalGuardianProperVerificationForm =
          FormUtils.initFormGroupFromTemplate(
            isv_tutor_proper_verification_form_template,
            isv_tutor_proper_verification_form_validators
          );
    }

    if (type !== ESpecificBeneficiaryType.PERSONA_FISICA) {
      this.newContractorConsentsForm = FormUtils.initFormGroupFromTemplate(
        privacy_consents_PG_form_template,
        privacy_consents_PG_form_validators
      );
    } else {
      this.newContractorConsentsForm = FormUtils.initFormGroupFromTemplate(
        privacy_consents_form_template,
        privacy_consents_form_validators
      );
      this.additionalForm = FormUtils.initFormGroupFromTemplate(
        legal_guardian_form_template,
        legal_guardian_form_validators
      );
    }
  }

  initializeOperationDataForm(): void {
    const operationDataFormTemplate = IsvUtils.retrieveOperationTemplate(
      this.operationId,
      this.policyId,
      CommonUtils.checkAndGet(
        this._policyService.policyDetail,
        'policyExtraInfo.branchOffice',
        null
      ),
      CommonUtils.checkAndGet(
        this._policyService.policyDetail,
        'policyValue.insuredAmount',
        null
      ),
      this._policyService.policyDetail
    );
    const operationDataFormValidators = IsvUtils.retrieveOperationValidators(
      this.operationId
    );
    this.operationDataForm = FormUtils.initFormGroupFromTemplate(
      operationDataFormTemplate,
      operationDataFormValidators
    );
    let operatorDataFormTemplate = {
      ...operator_data_form_template,
      subscriptionDate: { value: moment(), disabled: true },
    };
    this.operatorDataForm = FormUtils.initFormGroupFromTemplate(
      operatorDataFormTemplate,
      operator_data_form_validators
    );
  }

  initializeLegalGuardianForms(): void {
    const legalGuardianData: IPersonIntesa = (
      this.policyHolderData as ILegalPersonIntesa
    )?.anagraficaRappresentanteLegale;
    const registryFormTemplate =
      IsvUtils.initializeLegalGuardianRegistryFormTemplate(legalGuardianData);
    this.legalGuardianRegistryForm = FormUtils.initFormGroupFromTemplate(
      registryFormTemplate,
      isv_legal_guardian_registry_form_validators
    );
    const residenceFormTemplate = CommonUtils.isVoidObj(
      legalGuardianData?.datiResidenza
    )
      ? isv_contractor_residence_form_template
      : legalGuardianData?.datiResidenza;
    this.legalGuardianResidenceForm = FormUtils.initFormGroupFromTemplate(
      residenceFormTemplate,
      isv_contractor_residence_form_validators
    );
    const indirizzoRecapito = CommonUtils.isVoidObj(
      legalGuardianData?.indirizzoRecapito
    )
      ? isv_contractor_address_form_template
      : legalGuardianData?.indirizzoRecapito;
    const addressFormTemplate = {
      ...indirizzoRecapito,
      sameAsResidence: null,
    };
    this.legalGuardianAddressForm = FormUtils.initFormGroupFromTemplate(
      addressFormTemplate,
      isv_contractor_address_form_validators
    );
    const idDocumentFormTemplate = {
      ...document_change_form_template,
      ...legalGuardianData?.documentoRiconoscimento,
    };
    this.legalGuardianIdentificationDocumentForm =
      FormUtils.initFormGroupFromTemplate(
        idDocumentFormTemplate,
        document_change_form_validators
      );
  }

  initializeVCONTLegalGuardianForms(): void {
    const registryFormTemplate =
      IsvUtils.initializeNewContractorLegalGuardianRegistryFormTemplate(
        this.searchedLegalGuardian
      );
    this.legalGuardianRegistryForm = FormUtils.initFormGroupFromTemplate(
      registryFormTemplate,
      isv_legal_guardian_registry_form_validators
    );
    const residenceFormTemplate = {
      stato: this.newContractorData?.fiscalAddress?.CodiceNazione,
      localita: this.newContractorData?.fiscalAddress?.Comune,
      provincia: this.newContractorData?.fiscalAddress?.CodiceProvincia,
      cap: this.newContractorData?.fiscalAddress?.Cap,
      indirizzo: this.newContractorData?.fiscalAddress?.Indirizzo,
    };
    this.legalGuardianResidenceForm = FormUtils.initFormGroupFromTemplate(
      residenceFormTemplate,
      isv_contractor_residence_form_validators
    );
    const addressFormTemplate = {
      stato: this.newContractorData?.contactAddress?.CodiceNazione,
      localita: this.newContractorData?.contactAddress?.Comune,
      provincia: this.newContractorData?.contactAddress?.CodiceProvincia,
      cap: this.newContractorData?.contactAddress?.Cap,
      indirizzo: this.newContractorData?.contactAddress?.Indirizzo,
      sameAsResidence: null,
    };
    this.legalGuardianAddressForm = FormUtils.initFormGroupFromTemplate(
      addressFormTemplate,
      isv_contractor_address_form_validators
    );
    const idDocumentFormTemplate =
      IsvUtils.initializeNewContractorDocumentFormTemplate(
        this.searchedLegalGuardian
      );
    this.legalGuardianIdentificationDocumentForm =
      FormUtils.initFormGroupFromTemplate(
        idDocumentFormTemplate,
        document_change_form_validators
      );
    this.legalGuardianProperVerificationForm =
      FormUtils.initFormGroupFromTemplate(
        isv_tutor_proper_verification_form_template,
        isv_tutor_proper_verification_form_validators
      );
  }

  initializeOperationForm(): void {
    let validators: any = null;
    let template: any = null;
    switch (this.operationId) {
      case '_VAGG':
        template = this.isPolicyPrevidenziale
          ? prev_payment_form_template
          : payment_form_template;
        validators = this.isPolicyPrevidenziale
          ? prev_payment_form_validators
          : payment_form_validators;
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          template,
          validators
        );
        if (!this.isPolicyPrevidenziale) {
          this.firstStepForm.get('amount')?.valueChanges.subscribe((value) => {
            if (value) {
              this.operationDataForm?.get('operationAmount')?.setValue(value);
            }
          });
        }
        break;
      case '_INPAG':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          premium_payment_suspension_form_template,
          premium_payment_suspension_form_validators
        );
        break;
      case '_RIAPU':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          premium_payment_reactivation_form_template,
          premium_payment_reactivation_form_validators
        );
        break;
      case '_VPRFR':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          frequency_premium_amount_change_previdenziali_form_template,
          frequency_premium_amount_change_previdenziali_form_validators
        );
        this.additionalForm = FormUtils.initFormGroupFromTemplate(
          variation_options_form_template,
          variation_options_form_validators
        );
        break;
      case '_RISTO': // riscatto totale
        validators = isv_total_redeem_form_validators;
        if (this._policyService.isLegalSubject) {
          validators = {
            ...validators,
            fiscalRegime: [Validators.required]
          };
        }
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          isv_total_redeem_form_template,
          validators
        );
        break;
      case '_RISPA': // riscatto parziale
        validators = isv_partial_redeem_form_validators;
        if (this._policyService.isLegalSubject) {
          validators = {
            ...validators,
            fiscalRegime: [Validators.required]
          };
        }
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          isv_partial_redeem_form_template,
          validators
        );
        this.firstStepForm.get('amount')?.valueChanges.subscribe((value) => {
          if (value) {
            this.operationDataForm?.get('operationAmount')?.setValue(value);
          }
        });
        break;
      case '10': // liquidazione a scadenza
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          liquidation_maturity_form_template,
          liquidation_maturity_form_validators
        );
        break;
      case 'INT_002': // aggiornamento documento identita
        this.firstStepForm = this._policyService.isDetailPrevidenziale
          ? FormUtils.initFormGroupFromTemplate(
              document_change_previdence_form_template,
              document_change_previdence_form_validators
            )
          : FormUtils.initFormGroupFromTemplate(
              'documentoRiconoscimento' in this.policyHolderData
                ? (this.policyHolderData as IPersonIntesa)
                    ?.documentoRiconoscimento
                : document_change_form_template,
              document_change_form_validators
            );
        break;
      case 'INT_001': // variazione filiale
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          branch_office_variation_form_template,
          branch_office_variation_form_validators
        );
        break;
      case '69': // variazione residenza
        if (this._policyService.isDetailPrevidenziale) {
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            residence_change_previdence_form_template,
            residence_change_previdence_form_validators
          );
        } else {
          const indirizzoResidenza = this._policyService.isLegalSubject
            ? (this.policyHolderData as ILegalPersonIntesa).indirizzoSedeLegale
            : (this.policyHolderData as IPersonIntesa).datiResidenza;
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            indirizzoResidenza,
            isv_contractor_residence_form_validators
          );
          this.additionalForm = FormUtils.initFormGroupFromTemplate(
            this.policyHolderData.indirizzoRecapito,
            isv_contractor_address_form_validators
          );
          this.additionalForm.disable();
        }
        break;
      case '_VRECP': // variazione recapito
        const indirizzoRecapito = this._policyService.isLegalSubject
          ? (this.policyHolderData as ILegalPersonIntesa).indirizzoSedeLegale
          : (this.policyHolderData as IPersonIntesa).datiResidenza;
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          { ...this.policyHolderData.indirizzoRecapito, sameAsResidence: null },
          isv_contractor_address_form_validators
        );

        this.additionalForm = FormUtils.initFormGroupFromTemplate(
          indirizzoRecapito,
          isv_contractor_residence_form_validators
        );
        this.additionalForm.disable();
        break;
      case 'INT_003': // rettifica anagrafica
        let registryFormTemplate: any = null;
        if ('cognome' in this.policyHolderData) {
          registryFormTemplate =
            IsvUtils.initializeRegistryFormTemplateForRegistryAdjustment(
              this.policyHolderData as IPersonIntesa
            );
        }
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          registryFormTemplate,
          registry_adjustment_form_validators
        );
        break;
      case '_SIMOR': // comunicazione sinistro
        const insuredRegistryTemplate =
          IsvUtils.initializeRegistryFormTemplateForInsured(
            CommonUtils.checkAndGet(
              this._policyService.policyDetail,
              'insured',
              null
            )
          );
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          insuredRegistryTemplate,
          claim_notification_validators
        );
        this.additionalForm = FormUtils.initFormGroupFromTemplate(
          declarant_claim_notification_template,
          declarant_claim_notification_validators
        );
        break;
      case 'INT_006':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          retirement_date_form_template,
          retirement_date_form_validators
        );
        break;
      case 'INT_005':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          debit_date_form_template,
          debit_date_form_validators
        );
        break;
      case '_SWITR': // Switch Fondi
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          divestment_isp_form_template,
          divestment_isp_form_validators
        );
        this.additionalForm = FormUtils.initFormGroupFromTemplate(
          investment_isp_form_template,
          investment_isp_form_validators
        );
        break;
      case 'INT_008': // Reindirizzamento Fondo
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          funds_relocation_form_template
        );
        break;
      case '_SWITC': // Variazione Linea Investimento
        if (this._policyService.isDetailPrevidenziale) {
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            previdential_change_investment_line_form_template,
            previdential_change_investment_line_form_validators
          );
        } else {
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            life_change_investment_line_form_template,
            life_change_investment_line_form_validators
          );
        }
        break;
      case '_VCONT':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          search_form_template,
          search_form_validators
        );
        break;
      case '_VCBMU': // Variazione Conto Corrente uni20
        if (this.isPrevidentialPolicy) {
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            bank_account_update_form_template,
            bank_account_update_form_validators
          );
        } else {
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(
            bank_account_change_form_template,
            bank_account_change_form_validators
          );
        }
        break;
      case '_VBENE':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(
          beneficiary_change_form_template_previdential_intros,
          beneficiary_change_form_validators_previdential_intros
        );
        break;
      default:
        this.firstStepForm = new FormGroup({ '': new FormControl('') });
        break;
    }
    LoggerService.logInfo(
      this.constructor.name,
      'initializeOperationForm',
      this.firstStepForm
    );
  }

  disableAllForms(): void {
    this.firstStepForm?.disable();
    this.additionalForm?.disable();
    this.ndgVariationForm?.disable();
    this.contractorRegistryForm?.disable();
    this.contractorResidenceForm?.disable();
    this.contractorAddressForm?.disable();
    this.contractorIdentificationDocumentForm?.disable();
    this.contractorBusinessForm?.disable();
    this.newContractorProperVerificationForm?.disable();
    this.newContractorConsentsForm?.disable();
    this.legalGuardianRegistryForm?.disable();
    this.legalGuardianResidenceForm?.disable();
    this.legalGuardianAddressForm?.disable();
    this.legalGuardianIdentificationDocumentForm?.disable();
    this.legalGuardianProperVerificationForm?.disable();
    this.insuredForm?.disable();
    this.beneficiaryForm?.disable();
    this.operationDataForm?.disable();
    this.operatorDataForm?.disable();
  }

  onModifiedOrAddedEmployer(newEmployer: any) {
    this.currentEmployersData = newEmployer;
    this.firstStepFormTouched = true;
  }

  onInsuredFormChange(insuredForm: FormGroup): void {
    LoggerService.logInfo(
      this.constructor.name,
      'onInsuredFormChange',
      insuredForm
    );
    if (insuredForm) {
      this.insuredForm = insuredForm;
    }
  }

  onBeneficiaryFormChange(beneficiaryForm: FormGroup): void {
    LoggerService.logInfo(
      this.constructor.name,
      'onbeneficiaryFormChange',
      beneficiaryForm
    );
    if (beneficiaryForm) {
      this.beneficiaryForm = beneficiaryForm;
    }
  }

  onPresetsValidChange(assets: IPolicyAsset[]): void {
    this.presetValid = assets.length > 0;
    this.activeFunds = assets;
  }
  // endregion

  // region MODALS

  openCheckInsuredModal(): Observable<any> {
    return this._dialog
      .open(BasicModalComponent, {
        data: {
          title: 'Attenzione',
          text: "L'assicurato è ancora in vita?",
          modalSize: 'modal-box-small text-center',
          buttons: [NO_BUTTON, YES_BUTTON],
        },
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        take(1),
        switchMap((outcome) => {
          return of(outcome);
        })
      );
  }

  openCheckBeneficiaryCoincidenceWithHolderModal(): Observable<any> {
    return this._dialog
      .open(BasicModalComponent, {
        data: {
          title: 'Attenzione',
          text: CHECK_REDEEM_INTENT_MSG,
          modalSize: 'modal-box-small text-center',
          buttons: [NO_BUTTON, YES_BUTTON],
        },
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        take(1),
        switchMap((outcome) => {
          return of(outcome);
        })
      );
  }

  openCheckTutorModal(): Observable<any> {
    return this._dialog
      .open(BasicModalComponent, {
        data: {
          title: 'Attenzione',
          text: CHECK_TUTOR_MSG,
          modalSize: 'modal-box-small text-center',
          buttons: [NO_BUTTON, YES_BUTTON],
        },
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        take(1),
        switchMap((outcome) => {
          this._spinner.show();
          this.customerHasTutor = outcome === EModalOutput.YES;
          if (this.customerHasTutor) {
            this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(
              ndg_variation_form_template,
              ndg_variation_form_validators
            );
            return this._policyService.retrieveNdgList(this._policyService.contractNumber);
          } else {
            return of(null);
          }
        })
      );
  }

  openBackToPolicyModal(message: string, title?: string): void {
    this._dialog
      .open(BasicModalComponent, {
        data: {
          title: title ? title : 'Attenzione!',
          text: message,
          modalSize: 'modal-box-small align-items-center text-center',
          buttons: [BACK_TO_POLICY_BUTTON],
        },
        disableClose: true,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((outcome) => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this.navigateToPolicy();
        }
      });
  }

  navigateToPolicy(): void {
    this._policyService.refreshPolicyDetail(true);
    this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
  }

  openConfirmOperationModal(): void {
    this._dialog
      .open(BasicModalComponent, {
        data: {
          title: 'Attenzione',
          text: "Procedere con la conferma dell'operazione?",
          modalSize: 'modal-box-small text-center',
          buttons: [NO_BUTTON, YES_BUTTON],
        },
        disableClose: true,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((outcome) => {
        if (outcome === EModalOutput.YES) {
            if (this.operationId === '_VAGG' && !this.isPolicyPrevidenziale) {
                this.checkTariffazione();
                return;
            } else if ((this.operationId === '_RISPA' && this.selectedRedemptionType !== 'NonDefinito') && !this.isPolicyPrevidenziale) {
                this.perfezionareTariffazione();
                return;
            }
            this.confirmOperation();
        }
      });
  }

  openHelpDeskAccountModal() {
      this._dialog.open(BasicModalComponent, {
        data: {
          title: "Attenzione",
          text: "Simulazione completata. Non è possibile procedere agli step successivi.",
          modalSize: 'modal-box-small text-center',
          buttons: [
            BACK_BUTTON,
            BACK_TO_POLICY_BUTTON
          ]
        },
        disableClose: true
      })
        .afterClosed()
        .pipe(take(1))
        .subscribe(outcome => {
          LoggerService.logInfo(this.constructor.name, 'openHelpDeskAccountModal');
          if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
            this._policyService.refreshPolicyDetail(true);
            this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
          }
        })
    }

  openWaitingOperationModal(): void {
      const statusCheck$ = interval(5000).pipe(
        switchMap(() => this.retrieveDraftStatus()),
        takeUntil(timer(30000))
      );

      const subscription = statusCheck$.subscribe({
        next: (isStatusChanged) => {
          if (!!isStatusChanged) {
            subscription.unsubscribe();
            this._dialog.closeAll();
            this._policyService.refreshPolicyDetail(true);
            const company = CommonUtils.getCompanyCode(this._policyService.companyId);
            this._router.navigate([`/policies/${this._policyService.contractNumber}/${company}/operations/${this.operationId}`]);
          }
        },
        error: () => {
          subscription.unsubscribe();
          this.openBlockOperationModal();
        },
        complete: () => {
          subscription.unsubscribe();
          this._dialog.closeAll();
          this.openBlockOperationModal();
        }
      });

      this._dialog.open(BasicModalComponent, {
        data: {
          title: "Attenzione!",
          text: "L'operazione sta richiedendo più tempo del previsto. Si prega di attendere.",
          modalSize: 'modal-box-small align-items-center text-center'
        },
        disableClose: true
      })
        .afterClosed()
        .pipe(take(1))
        .subscribe();
    }

  openBlockOperationModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: "L'operazione sta richiedendo più tempo del previsto. Si prega di uscire e contattare l'assistenza.",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  // endregion

  // region STEPPER

  manageStepper(): void {
    // Fallback in case selectedIndex is too big
    if (this.selectedIndex >= this.isvStepper.steps.length) {
      this.selectedIndex = this.isvStepper.steps.length - 1;
    }
    for (let i = 0; i < this.selectedIndex; i++) {
      const step = this.isvStepper.steps.toArray()[i];
      step.completed = true;
    }
  }

  previous(stepName: string): void {
    if (stepName === 'INVESTMENT_STEP' && !this.isReadOnly) {
      this.investmentFunds.forEach((fund) => {
        fund.amount = '0,00';
      });
    }
    this.isvStepper.previous();
  }

  next(): void {
    this.isvStepper.next();
  }

  goToNextStep(stepName: string): void {
    const shouldUpdateDraft =
      !this.isReadOnly &&
      [
        'OPERATION_STEP',
        'NDG_VARIATION_STEP',
        'REGISTRY_RECAP_STEP',
        'DISINVESTMENT_STEP',
      ].includes(stepName);
    if (shouldUpdateDraft) {
      this.updateDraft();
    }
    if (stepName === 'OPERATION_STEP') {
      if (this.isHelpDeskAccount && this.isSimulatedOperation) {
        this.openHelpDeskAccountModal();
        return;
      }
      else if (this.isCancelOperation) {
        this.confirmOperation();
      } else if (this.isReadOnly || this.hasQuestionnaireStep) {
        if (this.operationId === '_RISPA' && this.selectedRedemptionType === 'Selettivo') {
            this.checkTariffazione();
        } else {
            this.next();
        }
      } else {
        this.openConfirmOperationModal();
      }
    } else if (stepName === 'NAVIGATE_POLICY') {
      this.navigateToPolicy();
    } else if (stepName === 'REGISTRY_RECAP_STEP') {
      if (this.isHelpDeskAccount && this.isSimulatedOperation) {
        this.openHelpDeskAccountModal();
        return;
      } else if (this.isReadOnly) {
        this.next();
      } else {
        this.openConfirmOperationModal();
      }
    } else {
      this.next();
    }
  }

  isStepValid(stepName: string): boolean {
    let isStepValid: boolean = false;
    switch (stepName) {
      case 'OPERATION_STEP':
        isStepValid = this.isOperationStepValid();
        break;
      case 'REGISTRY_RECAP_STEP':
        isStepValid = this.isRegistryRecapStepValid();
        break;
      case 'DISINVESTMENT_STEP':
        isStepValid = this.arePolicyFundsValid && this.isAmountValid;
        break;
      case 'INVESTMENT_STEP':
        if (this.isHelpDeskAccount) {
          isStepValid = NOT_DRAFT_OPERATION_STATES.includes(this.operationStatus as EDashboardStatus);
          break;
        }
        if (this.isPrevidentialPolicy) {
            isStepValid = this.investmentFunds.reduce(
                (acc, fund) => acc + parseFloat(fund.pInvestment.replace(',', '.')), 0) === 100
        } else {
            isStepValid = this.arePolicyAssetsAmountsValid;
        }
        break;
      default:
        break;
    }
    return isStepValid;
  }

  isRegistryRecapStepValid(): boolean {
    let isStepValid: boolean = false;
    if (this.isReadOnly && !this.isHelpDeskAccount) {
      return true;
    }
    if (NOT_DRAFT_OPERATION_STATES.includes(this.operationStatus as EDashboardStatus)) {
      return true;
    }
    if (this.operationId === '_VCONT') {
      const type = this.firstStepForm?.get('type')?.value;

      isStepValid =
        (this.newContractorSearched || this.contractorRegistryForm?.valid) &&
        this.contractorResidenceForm?.valid &&
        this.contractorAddressForm?.valid &&
        (type === ESpecificBeneficiaryType.PERSONA_FISICA ? this.contractorIdentificationDocumentForm?.valid : true) &&
        this.contractorBusinessForm?.valid &&
        this.newContractorConsentsForm?.valid &&
        (type === ESpecificBeneficiaryType.PERSONA_FISICA ? this.newContractorProperVerificationForm?.valid : true) &&
        this.operationDataForm?.valid &&
        this.operatorDataForm?.valid &&
        (CommonUtils.isVoidObj(this.searchedLegalGuardian) ? true : (
          this.legalGuardianRegistryForm?.valid &&
          this.legalGuardianResidenceForm?.valid &&
          this.legalGuardianAddressForm?.valid &&
          this.legalGuardianIdentificationDocumentForm?.valid &&
          this.legalGuardianProperVerificationForm?.valid
        )) &&
        (type === ESpecificBeneficiaryType.PERSONA_FISICA
            ? true
            : this.effectiveOwnersList?.length > 0 &&
            this.effectiveOwnersList.every(owner =>
                owner?.identificationDocumentForm?.valid &&
                owner?.registryForm?.valid &&
                owner?.residenceForm?.valid &&
                owner?.properVerificationForm?.valid
            ))
    } else {
      if (this._policyService.isLegalSubject) {
        isStepValid =
          this.contractorRegistryForm?.valid &&
          this.contractorResidenceForm?.valid;
        isStepValid =
          isStepValid &&
          this.legalGuardianRegistryForm?.valid &&
          this.legalGuardianResidenceForm?.valid &&
          this.legalGuardianAddressForm?.valid &&
          this.legalGuardianIdentificationDocumentForm?.valid;
        isStepValid =
            isStepValid &&
            this.effectiveOwnersList?.length > 0 &&
            this.effectiveOwnersList.every(owner =>
            owner?.identificationDocumentForm?.valid &&
            owner?.registryForm?.valid &&
            owner?.residenceForm?.valid
            );
      } else {
        isStepValid =
          this.contractorRegistryForm?.valid &&
          this.contractorResidenceForm?.valid &&
          this.contractorAddressForm?.valid &&
          this.contractorIdentificationDocumentForm?.valid &&
          this.contractorBusinessForm?.valid;
      }
      isStepValid =
        isStepValid &&
        this.operationDataForm?.valid &&
        this.operatorDataForm?.valid;
      if (this.operationDataForm?.get('contractorNotInsured')?.value === 'SI') {
        isStepValid = isStepValid && this.insuredForm?.valid;
      }
      if (this.operationDataForm?.get('designedBeneficiary')?.value === 'SI') {
        isStepValid = isStepValid && this.beneficiaryForm?.valid;
      }
    }
    return isStepValid;
  }

  isOperationStepValid(): boolean {
    let isStepValid: boolean = false;
    if (this.isHelpDeskAccount) {
      return this.operationStatus !== EDashboardStatus.DRAFT;
    }
    if (NOT_DRAFT_OPERATION_STATES.includes(this.operationStatus as EDashboardStatus)) {
      return true;
    }
    let amount = null;
    switch (this.operationId) {
      case '_VBENE':
        if (this.isPrevidentialPolicy) {
          isStepValid =
            this.previdentialBeneficiariesList?.length > 0 &&
            this.firstStepForm?.valid;
        } else {
          isStepValid =
            this.beneficiariesList?.length > 0 && this.isBeneficiariesStructureValid && !this.isReferenteEqualBeneficiary // && this.isThirdPartyValid;
        }
        break;
      case '_SIMOR':
        isStepValid = this.firstStepForm?.valid && this.additionalForm?.valid;
        break;
      case 'INT_002':
      case '69':
      case '_VRECP':
      case 'INT_003':
      case '_VCBMU':
        isStepValid =
          this.firstStepForm?.valid &&
          (this.firstStepFormTouched || this.firstStepForm?.touched) &&
          !(this.ibansList && this.ibansList.length === 1 && this.ibansList.some(obj => obj?.abiRapporto + obj?.cabRapporto + obj?.numeroRapporto === this.currentBankAccount));
        break;
      case 'INT_010':
        isStepValid = this.firstStepFormTouched;
        break;
      case 'INT_004':
        isStepValid = !!this.payerToUpdate;
        break;
      case '_RISPA':
        amount = this.firstStepForm?.get('amount')?.value?.split('.').join('');
        amount = parseFloat(amount?.replace(',', '.'));
        isStepValid =
          !this.hasErrored &&
          this.firstStepForm?.valid &&
          amount > 0 &&
          (this.activeFunds?.length > 0 ? this.arePolicyFundsValid : true);
        break;
      case '_VCONT':
        isStepValid =
          this.newContractorSearched &&
          this.firstStepForm?.valid &&
          (this.additionalForm &&
          this.additionalForm?.valid &&
          this.additionalForm?.get('isContractorCapable')?.value === 'SI'
            ? true
            : !CommonUtils.isVoidObj(this.searchedLegalGuardian));
        break;
      case '_VAGG':
        amount = this.firstStepForm?.get('amount')?.value ?? '0';
        amount = amount.replace(/\./g, '');
        amount = amount.replace(',', '.');
        isStepValid = this.firstStepForm?.valid && parseFloat(amount) > 0 && this.presetValid;
        break;
      case 'INT_008':
        const initialAllocation = this.firstStepForm?.getRawValue();

        if (!initialAllocation) {
            isStepValid = false;
            return;
        }

        const { reallocationTFRTotal, reallocationCompanyTotal, reallocationSubscriberTotal } =
        this.investmentFunds.reduce(
            (acc, fund) => {
                acc.reallocationTFRTotal += parseFloat((fund.TFRAllocation.replace(',', '.')) || '0');
                acc.reallocationCompanyTotal += parseFloat((fund.companyAllocation.replace(',', '.')) || '0');
                acc.reallocationSubscriberTotal += parseFloat((fund.subscriberAllocation.replace(',', '.')) || '0');
                return acc;
            },
            { reallocationTFRTotal: 0, reallocationCompanyTotal: 0, reallocationSubscriberTotal: 0 }
        );

        isStepValid =
            reallocationCompanyTotal === initialAllocation.companyAllocation &&
            reallocationSubscriberTotal === initialAllocation.subscriberAllocation &&
            reallocationTFRTotal === initialAllocation.TFRAllocation;
        break;
      default:
        isStepValid = this.firstStepForm?.valid;
        break;
    }
    return isStepValid;
  }

  showPreviousButton(stepName: string): boolean {
    let showButton: boolean = false;
    switch (stepName) {
      case 'OPERATION_STEP': // step 'Inserimento operazione'
        if (this.customerHasTutor) {
          showButton = true;
        }
        break;
      default:
        break;
    }
    return showButton;
  }

  // endregion

  // region DOCUMENTS

  manageDocs(): void {
    this.subscribeToRetrieveDocuments();
    this.subscribeToRetrieveDownloadInfo();
    this.subscribeToUploadDoc();
    this.subscribeToDownloadDoc();
  }

  subscribeToRetrieveDocuments(): void {
    this._policyService.retireveDocumentsSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.retrieveDocuments();
      });
  }

  subscribeToRetrieveDownloadInfo(): void {
    this._policyService.retireveDownloadInfoSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((document: any) => {
        if (document && !this.isCancelOperation) {
          this.documentsList.forEach((doc) => {
            if (doc?.descrizioneDocumento === document?.descrizioneDocumento) {
              doc.isDownloading = true;
            }
          });
          this.documentsList = [...this.documentsList];
          this.startPolling(document);
        } else {
          this.manageCancelDoc(document);
        }
      });
  }

  subscribeToUploadDoc(): void {
    this._policyService.documentUploadSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((uploadDocumentObj: IUploadDocumentObj) => {
        if (!CommonUtils.isVoidObj(uploadDocumentObj)) {
          const formData: FormData = CommonUtils.checkAndGet(
            uploadDocumentObj,
            'formData',
            null
          );
          const url: string = CommonUtils.checkAndGet(
            uploadDocumentObj,
            'url',
            null
          );
          const headers: HttpHeaders = CommonUtils.checkAndGet(
            uploadDocumentObj,
            'headers',
            null
          );
          this.uploadDocument(url, formData, headers);
        }
      });
  }

  subscribeToDownloadDoc(): void {
    this._policyService.documentDownloadSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((document: IDocument) => {
        if (document) {
          this.downloadDocument(document);
        }
      });
  }

  uploadOperationFile(uploadDocumentObj: IUploadDocumentObj): void {
    const formData: FormData = CommonUtils.checkAndGet(
      uploadDocumentObj,
      'formData',
      null
    );
    const url: string = CommonUtils.checkAndGet(
      uploadDocumentObj,
      'url',
      null
    );
    const headers: HttpHeaders = CommonUtils.checkAndGet(
      uploadDocumentObj,
      'headers',
      null
    );
    this.uploadDocument(url, formData, headers);
  }

  retrieveDocuments(): void {
    this._spinner.show();
    const operationId = this.operationId;
    this._policyService
      .retrieveUploadDocuments(this.policyId, operationId, this.movementId, this.isCancelOperation)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'retrieveDocuments', {
            response,
          });
          this.documentsList = response.map((doc) => ({
            ...doc,
            isDownloaded: doc?.isDownloaded || doc?.userDownloaded,
          }));
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'retrieveDocuments', {
            error,
          });
          this._spinner.hide();
          this._alertService.openErrorMessage(
            ERR_DOC_RETRIEVE_MESSAGE,
            'retrieveDocuments',
            error
          );
        },
      });
  }

  startPolling(document: IDocument): void {
    const documentId = document?.codeInd;
    if (documentId.split('_')[0] !== 'DOW') {
        this.downloadDocument(document);
        return;
    }
    this._policyService
      .startPolling(
        documentId,
        this.operationId,
        this.movementId,
        this.policyId
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: HttpResponse<ICompanyDocumentResponse>) => {
          LoggerService.logInfo(this.constructor.name, 'startPolling', {
            response,
          });
          if (response.status === 200) {
            this.downloadDocument({
              ...document,
              S3DownloadInfo: CommonUtils.checkAndGet(
                response,
                'body.S3DownloadUrl',
                null
              ),
            });
          } else if (response.status > 400) {
            this.documentsList.forEach((doc) => {
              if (
                doc?.descrizioneDocumento === document?.descrizioneDocumento
              ) {
                doc.isDownloaded = false;
                doc.isDownloading = false;
              }
            });
            this.documentsList = [...this.documentsList];
            LoggerService.logError(this.constructor.name, 'startPolling', {
              response,
            });
            this._alertService.openErrorMessage(
              ERROR_DOWNLOADING_DOC_MESSAGE,
              'startPolling',
              response
            );
          }
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'startPolling', {
            error,
          });
          this._alertService.openErrorMessage(
            ERROR_DOWNLOADING_DOC_MESSAGE,
            'startPolling',
            error
          );
        },
      });
  }

  downloadDocument(document: IDocument): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocument', {
      document,
    });
    if (document && document?.S3DownloadInfo?.downloadUrl) {
      this._policyService
        .downloadDocument(document?.S3DownloadInfo?.downloadUrl)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response: Blob) => {
            LoggerService.logInfo(this.constructor.name, 'downloadDocument', {
              response,
            });
            if (response) {
              this.manageDownloadedDoc(response, document);
            }
          },
          error: (error) => {
            LoggerService.logError(this.constructor.name, 'downloadDocument', {
              error,
            });
            this._alertService.openErrorMessage(
              ERROR_DOWNLOADING_DOC_MESSAGE,
              'retrieveDocuments',
              error
            );
          },
        });
    }
  }

  manageDownloadedDoc(blob: Blob, doc: IDocument): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download =
      doc?.S3DownloadInfo?.fileName + '.' + doc?.S3DownloadInfo?.fileFormat;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.documentsList.forEach((document) => {
      if (document?.descrizioneDocumento === doc?.descrizioneDocumento) {
        document.isDownloaded = true;
        document.isDownloading = false;
      }
    });
    this.documentsList = [...this.documentsList];
    this.setDownloadedDoc({
      policyNumber: this.policyId,
      movementId: this.movementId,
      documentId: doc.codeInd,
    });
  }

  manageCancelDoc(doc: ICancelDocument): void {
    // decodifica Base64 in una stringa di byte
    const byteCharacters = atob(doc?.contentBuffer);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    // Crea un Blob a partire dall'array di byte
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob); // Crea un URL per il Blob
    const a = document.createElement('a'); // Crea un elemento <a> per avviare il download
    a.href = url;
    a.download = doc?.descrizioneDocumento + '.pdf'; // Setta il nome del file
    document.body.appendChild(a);
    a.click(); // Simula un click per avviare il download
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.documentsList.forEach((document) => {
      if (document?.descrizioneDocumento === doc?.descrizioneDocumento) {
        document.isDownloaded = true;
      }
    });
    this.documentsList = [...this.documentsList];
  }

  setDownloadedDoc(body: any): void {
    this._spinner.show();
    this._policyService
      .setDownloadedDoc(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'setDownloadedDoc', {
            response,
          });
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'setDownloadedDoc', {
            error,
          });
          this._alertService.openErrorMessage(
            'Errore',
            'setDownloadedDoc',
            error
          );
          this._spinner.hide();
        },
      });
  }

  uploadDocument(url: string, body: FormData, headers: HttpHeaders): void {
    LoggerService.logInfo(this.constructor.name, 'uploadDocument', {
      url: url,
      body: body,
      headers: headers,
    });
    if (url && body) {
      this._spinner.show();
      this._policyService
        .uploadDocument(url, body, headers)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            LoggerService.logInfo(this.constructor.name, 'uploadDocument', {
              response,
            });
            this._spinner.hide();
            this.retrieveDocuments();
          },
          error: (error) => {
            LoggerService.logError(this.constructor.name, 'uploadDocument', {
              error,
            });
            this._alertService.openErrorMessage(
              'Errore in fase di caricamento del documento',
              'uploadDocument',
              error
            );
            this._spinner.hide();
          },
        });
    }
  }

  retrieveCancelDocument(): void {
    this._spinner.show();
    this._policyService
      .retrieveCancelDocuments(this.policyId, this.movementId, this.movementId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'retrieveDocuments', {
            response,
          });
          if (CommonUtils.checkAndGet(response, 'state', null) === 'KO') {
            this._alertService.openErrorMessage(
              ERR_DOC_RETRIEVE_MESSAGE,
              'retrieveCancelDocument'
            );
          } else {
            const doc: ICancelDocument = {
              contentBuffer: CommonUtils.checkAndGet(
                response,
                'contentBuffer',
                null
              ),
              contentType: CommonUtils.checkAndGet(
                response,
                'contentType',
                null
              ),
              descrizioneDocumento: 'Annullo_' + this.movementId,
              isDownloaded: false,
              providedFromCompany: true,
            };
            this.documentsList = [doc];
          }
          this._spinner.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'retrieveDocuments', {
            error,
          });
          this._spinner.hide();
          this._alertService.openErrorMessage(
            ERR_DOC_RETRIEVE_MESSAGE,
            'retrieveCancelDocument',
            error
          );
        },
      });
  }

  // endregion

  // region GETTER

  get currentBankAccount(): string {
    let bankAccount: string = CommonUtils.checkAndGet(
      this._policyService.policyDetail,
      'policyValue.codeRapporto',
      null
    );
    if (bankAccount) {
      bankAccount = bankAccount.replace(/\./g, '');
    }
    return bankAccount;
  }

  get policyId(): string {
    return this._policyService.policyId;
  }

  get operationId(): string {
    return this._policyService.operationId;
  }

  get operationTitle(): string {
    return CommonUtils.getOperationTitle(
      this.operationId,
      this.operationsNamesList
    );
  }

  get isContractorLegalSubject(): boolean {
    return this._policyService.isLegalSubject;
  }

  get contractorTypeDescription(): string {
    return this.operationId === '_VCONT'
      ? this.firstStepForm?.get('type')?.value ===
        ESpecificBeneficiaryType.PERSONA_FISICA
        ? 'Fisica'
        : 'Giuridica'
      : this.isContractorLegalSubject
      ? 'Giuridica'
      : 'Fisica';
  }

  get policyHolderData(): IPersonIntesa | ILegalPersonIntesa {
    return this._policyService.policyHolderIntesa;
  }

  get policyLegalGuardian(): IPersonIntesa {
    return this._policyService.legalGuardianIntesa;
  }

  get hasInsuredCheck(): boolean {
    const operationsWithInsuredCheck: string[] = OP_WITH_INSURED_CHECK;
    return operationsWithInsuredCheck.includes(this.operationId);
  }

  get hasQuestionnaireStep(): boolean {
    const operationsWithQuestionnaire: string[] = this._policyService
      .isDetailPrevidenziale
      ? OP_WITH_QUESTIONNAIRE_UNI30
      : OP_WITH_QUESTIONNAIRE_UNI20;
    return operationsWithQuestionnaire.includes(this.operationId);
  }

  get canChangeNdg(): boolean {
    const operationsWithChangeNdg: string[] = CAN_CHANGE_NDG_ISV;
    const iddClassification = CommonUtils.checkAndGet(
      this._policyService.policyDetail,
      'summary.iddClassification',
      null
    );
    return operationsWithChangeNdg.includes(this.operationId) && iddClassification === 'IBIPS';
  }

  get isPolicyPrevidenziale(): boolean {
    return this._policyService.isDetailPrevidenziale;
  }

  get canSelectIban(): boolean {
    return ISV_OPERATIONS_WITH_IBAN.includes(this.operationId);
  }

  get cannotCallFormFields(): boolean {
    return (
      this.isPrevidentialPolicy &&
      CONNOT_CALL_FORM_FIELDS.includes(this.operationId)
    );
  }

  get isReadOnly(): boolean {
    return (
      this.operationStatus !== EDashboardStatus.DRAFT || this.cannotOperate
    );
  }

  get isHelpDeskAccount(): boolean {
    return this._authService.isHelpDeskAccount(this._policyService.policyType);
  }

  get isSimulatedOperation(): boolean {
    return this.isHelpDeskAccount && this.simulateOperation;
  }

  get hasWriteAbilitation(): boolean {
    return this._authService.hasWriteAbilitation(
      this._policyService.policyType
    );
  }

  get hasNoWriteAbilitation(): boolean {
    return this._authService.hasNoWriteAbilitation(this._policyService.policyType);
  }

  get isWriteDisabled(): boolean {
    return (this.hasNoWriteAbilitation && !this.isSimulatedOperation) || NOT_DRAFT_OPERATION_STATES.includes(this.operationStatus as EDashboardStatus);
  }

  get cannotOperate(): boolean {
    return this.isHelpDeskAccount || !this.hasWriteAbilitation;
  }

  get canOperateToday(): boolean {
    return this._policyService.canOperateToday;
  }

  get isDraft(): boolean {
    return this.operationStatus === EDashboardStatus.DRAFT;
  }

  get hasDocsToDownload(): boolean {
    return (
      this.documentsList &&
      this.documentsList.length > 0 &&
      this.documentsList.some(
        (document) => !document.isDownloaded && document.providedFromCompany
      )
    );
  }

  get hasDocsToUpload(): boolean {
    return (
      this.documentsList &&
      this.documentsList.some(
        (document) =>
          !document.providedFromCompany &&
          document.isMandatory &&
          !document.isUploaded
      )
    );
  }

  get isAlreadySubmitted(): boolean {
    return (
      this.operationStatus !== EDashboardStatus.DRAFT &&
      this.operationStatus !== EDashboardStatus.TO_UPLOAD
    );
  }

  get isCancelOperation(): boolean {
    return ISV_CANCEL_OPERATIONS.includes(this.operationId);
  }

  get documentReleaseAuthoritesList(): IFormSelectOption[] {
    return this._policyService.isDetailPrevidenziale
      ? this.documentReleaseAuthorities
      : this.documentReleaseAuthorityList;
  }

  get documentTypesList(): IFormSelectOption[] {
    return this._policyService.isDetailPrevidenziale
      ? this.documentTypesDomain
      : this.documentTypeList;
  }

  get isSingleStepOperation(): boolean {
    return !ISV_MULTI_STEP_OPERATIONS.includes(this.operationId);
  }

  get isAmountValid(): boolean {
    const amountControl = this.firstStepForm.get('amount');
    const value = amountControl ? parseFloat(amountControl.value) : 0;
    return value > 0;
  }

  get arePolicyFundsValid(): boolean {
    if (!this.activeFunds || this.activeFunds.length === 0) {
      return false;
    }

    return this.activeFunds.every((fund) => {
      let amount = fund.amount?.split('.').join('');
      amount = parseFloat(amount?.replace(',', '.'));

      let fundAmount = fund?.fundAmount?.split('.').join('');
      fundAmount = fundAmount?.replace(',', '.');

      const totalFundAmount = parseFloat(fundAmount);

      return (
        amount >= 0 && !isNaN(totalFundAmount) && amount <= totalFundAmount
      );
    });
  }

  get arePolicyAssetsAmountsValid(): boolean {
    let divestmentAmountString =
      this.firstStepForm?.get('amount')?.value ?? '0';
    divestmentAmountString = divestmentAmountString.replace(/\./g, '');
    divestmentAmountString = divestmentAmountString.replace(',', '.');

    let investmentsAmountString =
      this.additionalForm?.get('amount')?.value ?? '0';
    investmentsAmountString = investmentsAmountString.replace(/\./g, '');
    investmentsAmountString = investmentsAmountString.replace(',', '.');

    return (
      parseFloat(divestmentAmountString) === parseFloat(investmentsAmountString)
    );
  }

  // '6' = Beneficiari Nominativi
  // If the category is '6', there must be at least one beneficiary defined
  get isBeneficiariesStructureValid(): boolean {
    return this.beneficiariesList.every(
        (b) =>
        b.beneficiaryCategory?.toString() !== '6' ||
        (b.beneficiaries && b.beneficiaries.length > 0)
    );
  }

  get isReferenteEqualBeneficiary(): boolean {
    if (!this.beneficiariesList || this.beneficiariesList.length === 0) {
      return true;
    }
    return this.beneficiariesList.every((beneficiary) => {
        if (!beneficiary.beneficiaries || beneficiary.beneficiaries.length === 0 || !this.thirdParty) {
            return false;
        }
        return beneficiary.beneficiaries.every((bene) => {
            if ((bene.personData.fiscalCode || bene.personData.vatCode) && (this.thirdParty.fiscalCode || this.thirdParty.vatCode)) {
                return bene.personData.fiscalCode.toLowerCase() === this.thirdParty.fiscalCode.toLowerCase() ||
                    bene.personData.vatCode.toLowerCase() === this.thirdParty.vatCode.toLowerCase();
            }
            return false
        })
    });
  }

  get ndgTutoreODelegato(): string {
    return this.searchedTutor && this.searchedTutor['ns2:ndg']
      ? this.searchedTutor['ns2:ndg']
      : undefined;
  }

  get tutorHasValidDocument(): boolean {
    if (this.ndgVariationForm) {
      const documentExpireDate = CommonUtils.checkAndGet(this.searchedTutor, 'ns2:datiDocumento.ns2:dataScadenza', null);
      if (documentExpireDate) {
        return moment().isBefore(moment(documentExpireDate));
      } else {
        return false;
      }
    }
  }

  // endregion
}
